function PlanJJ({ ...props }) {
	return (
		<g {...props} id="unit-jj">
			<g id="furniture">
				<polyline
					points="595.66 740.05 599.15 740.05 599.15 741.82 595.66 741.82 595.66 740.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="808.17"
					y1="551.48"
					x2="808.17"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="551.48"
					x2="808.17"
					y2="551.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="524.96"
					x2="650.96"
					y2="551.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="524.96"
					x2="805.49"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.16"
					y1="524.96"
					x2="791.91"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.37"
					y1="524.96"
					x2="785.13"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.58"
					y1="524.96"
					x2="778.34"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.8"
					y1="524.96"
					x2="771.56"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.01"
					y1="524.96"
					x2="764.77"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.22"
					y1="524.96"
					x2="757.98"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.44"
					y1="524.96"
					x2="751.2"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.65"
					y1="524.96"
					x2="744.41"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.86"
					y1="524.96"
					x2="737.62"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.08"
					y1="524.96"
					x2="730.84"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.29"
					y1="524.96"
					x2="724.05"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.5"
					y1="524.96"
					x2="717.26"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.72"
					y1="524.96"
					x2="710.48"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.93"
					y1="524.96"
					x2="703.69"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.14"
					y1="524.96"
					x2="696.9"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.36"
					y1="524.96"
					x2="690.11"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.57"
					y1="524.96"
					x2="683.33"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.78"
					y1="524.96"
					x2="676.54"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674"
					y1="524.96"
					x2="669.75"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.21"
					y1="524.96"
					x2="662.96"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.42"
					y1="524.96"
					x2="656.18"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.64"
					y1="524.96"
					x2="650.96"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="524.96"
					x2="650.96"
					y2="529.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="531.82"
					x2="650.96"
					y2="536.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="538.61"
					x2="650.96"
					y2="542.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="545.4"
					x2="650.96"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.96"
					y1="549.71"
					x2="653.64"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.18"
					y1="549.71"
					x2="660.42"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.96"
					y1="549.71"
					x2="667.21"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.75"
					y1="549.71"
					x2="674"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.54"
					y1="549.71"
					x2="680.78"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.33"
					y1="549.71"
					x2="687.57"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.11"
					y1="549.71"
					x2="694.36"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.9"
					y1="549.71"
					x2="701.14"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.69"
					y1="549.71"
					x2="707.93"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.48"
					y1="549.71"
					x2="714.72"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.26"
					y1="549.71"
					x2="721.5"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.05"
					y1="549.71"
					x2="728.29"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.84"
					y1="549.71"
					x2="735.08"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.62"
					y1="549.71"
					x2="741.86"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.41"
					y1="549.71"
					x2="748.65"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.2"
					y1="549.71"
					x2="755.44"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.98"
					y1="549.71"
					x2="762.22"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.77"
					y1="549.71"
					x2="769.01"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.56"
					y1="549.71"
					x2="775.8"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.34"
					y1="549.71"
					x2="782.58"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.13"
					y1="549.71"
					x2="789.37"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.91"
					y1="549.71"
					x2="796.16"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.7"
					y1="549.71"
					x2="802.94"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.49"
					y1="549.71"
					x2="808.17"
					y2="549.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="549.71"
					x2="808.17"
					y2="545.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="542.85"
					x2="808.17"
					y2="538.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="536.06"
					x2="808.17"
					y2="531.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="529.28"
					x2="808.17"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.15"
					y1="516.13"
					x2="680"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="516.13"
					x2="680"
					y2="489.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="489.62"
					x2="773.15"
					y2="489.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.15"
					y1="516.13"
					x2="771.83"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.41"
					y1="516.13"
					x2="765.17"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.63"
					y1="516.13"
					x2="758.39"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.84"
					y1="516.13"
					x2="751.6"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.05"
					y1="516.13"
					x2="744.81"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.27"
					y1="516.13"
					x2="738.03"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.48"
					y1="516.13"
					x2="731.24"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.69"
					y1="516.13"
					x2="724.45"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.91"
					y1="516.13"
					x2="717.66"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.12"
					y1="516.13"
					x2="710.88"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.33"
					y1="516.13"
					x2="704.09"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.55"
					y1="516.13"
					x2="697.3"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.76"
					y1="516.13"
					x2="690.51"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.97"
					y1="516.13"
					x2="683.73"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.31"
					y1="516.13"
					x2="680"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="516.13"
					x2="680"
					y2="511.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="509.27"
					x2="680"
					y2="505.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="502.48"
					x2="680"
					y2="498.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="495.69"
					x2="680"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680"
					y1="491.38"
					x2="681.31"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.73"
					y1="491.38"
					x2="687.97"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.51"
					y1="491.38"
					x2="694.76"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.3"
					y1="491.38"
					x2="701.55"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.09"
					y1="491.38"
					x2="708.33"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.88"
					y1="491.38"
					x2="715.12"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.66"
					y1="491.38"
					x2="721.91"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.45"
					y1="491.38"
					x2="728.69"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.24"
					y1="491.38"
					x2="735.48"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.03"
					y1="491.38"
					x2="742.27"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.81"
					y1="491.38"
					x2="749.05"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.6"
					y1="491.38"
					x2="755.84"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.39"
					y1="491.38"
					x2="762.63"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.17"
					y1="491.38"
					x2="769.41"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.83"
					y1="491.38"
					x2="773.15"
					y2="491.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.15"
					y1="511.81"
					x2="773.15"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.43"
					y1="751.12"
					x2="401.43"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.08"
					y1="751.12"
					x2="416.84"
					y2="751.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.3"
					y1="751.12"
					x2="410.05"
					y2="751.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.51"
					y1="751.12"
					x2="403.19"
					y2="751.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="751.12"
					x2="403.19"
					y2="749.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="746.8"
					x2="403.19"
					y2="742.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="740.02"
					x2="403.19"
					y2="735.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="733.23"
					x2="403.19"
					y2="728.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="726.44"
					x2="403.19"
					y2="722.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="719.66"
					x2="403.19"
					y2="715.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="712.87"
					x2="403.19"
					y2="708.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="706.08"
					x2="403.19"
					y2="701.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="699.3"
					x2="403.19"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.19"
					y1="697.52"
					x2="407.51"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.05"
					y1="697.52"
					x2="414.3"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.84"
					y1="697.52"
					x2="421.08"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="690.7"
					x2="676.9"
					y2="787.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="743.58"
					x2="587.73"
					y2="787.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="787.96"
					x2="676.9"
					y2="787.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="743.58"
					x2="566.52"
					y2="747.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="750.5"
					x2="566.52"
					y2="754.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="757.29"
					x2="566.52"
					y2="761.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="764.07"
					x2="566.52"
					y2="768.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="770.86"
					x2="566.52"
					y2="775.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="777.65"
					x2="566.52"
					y2="781.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="784.44"
					x2="566.52"
					y2="788.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="791.22"
					x2="566.52"
					y2="795.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="798.01"
					x2="566.52"
					y2="802.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="804.8"
					x2="566.52"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="442.59 701.41 490.31 701.41 490.31 749.13 442.59 749.13 442.59 701.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="52.84 717.52 52.84 747.78 56.67 747.78 56.67 717.52 52.84 717.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="52.49 749.17 52.49 716.13 52.84 716.13 52.84 749.17 52.49 749.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="52.49"
					y1="749.17"
					x2="52.49"
					y2="716.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.49"
					y1="716.13"
					x2="52.84"
					y2="716.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="716.13"
					x2="52.84"
					y2="749.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="749.17"
					x2="52.49"
					y2="749.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.67"
					y1="717.52"
					x2="56.67"
					y2="747.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="747.78"
					x2="52.84"
					y2="717.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="56.67 714.39 56.67 717.52 52.84 717.52 52.84 714.39 56.67 714.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="56.67"
					y1="714.39"
					x2="56.67"
					y2="717.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.67"
					y1="717.52"
					x2="52.84"
					y2="717.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="717.52"
					x2="52.84"
					y2="714.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="714.39"
					x2="56.67"
					y2="714.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="52.84 750.91 52.84 747.78 56.67 747.78 56.67 750.91 52.84 750.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="52.84"
					y1="750.91"
					x2="52.84"
					y2="747.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="747.78"
					x2="56.67"
					y2="747.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.67"
					y1="747.78"
					x2="56.67"
					y2="750.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.67"
					y1="750.91"
					x2="52.84"
					y2="750.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="53.54"
					y1="717.52"
					x2="53.54"
					y2="747.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="56.32 713 56.32 714.39 52.84 714.39 52.84 716.13 52.49 716.13 52.49 713 56.32 713"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="56.32"
					y1="713"
					x2="56.32"
					y2="714.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.32"
					y1="714.39"
					x2="52.84"
					y2="714.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="714.39"
					x2="52.84"
					y2="716.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="716.13"
					x2="52.49"
					y2="716.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.49"
					y1="716.13"
					x2="52.49"
					y2="713"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.49"
					y1="713"
					x2="56.32"
					y2="713"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="52.49 752.3 52.49 749.17 52.84 749.17 52.84 750.91 56.32 750.91 56.32 752.3 52.49 752.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="52.49"
					y1="752.3"
					x2="52.49"
					y2="749.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.49"
					y1="749.17"
					x2="52.84"
					y2="749.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="749.17"
					x2="52.84"
					y2="750.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.84"
					y1="750.91"
					x2="56.32"
					y2="750.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.32"
					y1="750.91"
					x2="56.32"
					y2="752.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="56.32"
					y1="752.3"
					x2="52.49"
					y2="752.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="53.54 754.07 55.3 754.07 55.3 847.92 53.54 847.92 53.54 754.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="53.54"
					y1="754.07"
					x2="55.3"
					y2="754.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="55.3"
					y1="754.07"
					x2="55.3"
					y2="847.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="55.3"
					y1="847.92"
					x2="53.54"
					y2="847.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="53.54"
					y1="847.92"
					x2="53.54"
					y2="754.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="53.54 713 53.54 709.47 64.14 709.47 64.14 713 53.54 713"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="53.54"
					y1="709.47"
					x2="53.54"
					y2="713"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="709.47"
					x2="53.54"
					y2="709.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="713"
					x2="64.14"
					y2="709.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="53.54"
					y1="713"
					x2="64.14"
					y2="713"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="53.54 755.84 53.54 752.3 64.14 752.3 64.14 755.84 53.54 755.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="53.54"
					y1="752.3"
					x2="53.54"
					y2="755.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="752.3"
					x2="53.54"
					y2="752.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="755.84"
					x2="64.14"
					y2="752.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="53.54"
					y1="755.84"
					x2="64.14"
					y2="755.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="53.54 849.69 53.54 846.15 64.14 846.15 64.14 849.69 53.54 849.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="53.54"
					y1="846.15"
					x2="53.54"
					y2="849.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="846.15"
					x2="53.54"
					y2="846.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="849.69"
					x2="64.14"
					y2="846.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="53.54"
					y1="849.69"
					x2="64.14"
					y2="849.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.45 236.52 743.19 236.52 743.19 240.34 773.45 240.34 773.45 236.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="741.8 236.17 774.84 236.17 774.84 236.52 741.8 236.52 741.8 236.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="741.8"
					y1="236.17"
					x2="774.84"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.84"
					y1="236.17"
					x2="774.84"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.84"
					y1="236.52"
					x2="741.8"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.8"
					y1="236.52"
					x2="741.8"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.45"
					y1="240.34"
					x2="743.19"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="236.52"
					x2="773.45"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="776.58 240.34 773.45 240.34 773.45 236.52 776.58 236.52 776.58 240.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="776.58"
					y1="240.34"
					x2="773.45"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.45"
					y1="240.34"
					x2="773.45"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.45"
					y1="236.52"
					x2="776.58"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.58"
					y1="236.52"
					x2="776.58"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="740.06 236.52 743.19 236.52 743.19 240.34 740.06 240.34 740.06 236.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="740.06"
					y1="236.52"
					x2="743.19"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="236.52"
					x2="743.19"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="240.34"
					x2="740.06"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.06"
					y1="240.34"
					x2="740.06"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.45"
					y1="237.21"
					x2="743.19"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="777.97 240 776.58 240 776.58 236.52 774.84 236.52 774.84 236.17 777.97 236.17 777.97 240"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="777.97"
					y1="240"
					x2="776.58"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.58"
					y1="240"
					x2="776.58"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.58"
					y1="236.52"
					x2="774.84"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.84"
					y1="236.52"
					x2="774.84"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.84"
					y1="236.17"
					x2="777.97"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.97"
					y1="236.17"
					x2="777.97"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.67 236.17 741.8 236.17 741.8 236.52 740.06 236.52 740.06 240 738.67 240 738.67 236.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.67"
					y1="236.17"
					x2="741.8"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.8"
					y1="236.17"
					x2="741.8"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.8"
					y1="236.52"
					x2="740.06"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.06"
					y1="236.52"
					x2="740.06"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.06"
					y1="240"
					x2="738.67"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.67"
					y1="240"
					x2="738.67"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="736.9 237.21 736.9 238.98 643.05 238.98 643.05 237.21 736.9 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="736.9"
					y1="237.21"
					x2="736.9"
					y2="238.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.9"
					y1="238.98"
					x2="643.05"
					y2="238.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.05"
					y1="238.98"
					x2="643.05"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.05"
					y1="237.21"
					x2="736.9"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="777.97 237.21 781.51 237.21 781.51 247.82 777.97 247.82 777.97 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="781.51"
					y1="237.21"
					x2="777.97"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.51"
					y1="247.82"
					x2="781.51"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.97"
					y1="247.82"
					x2="781.51"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.97"
					y1="237.21"
					x2="777.97"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="735.13 237.21 738.67 237.21 738.67 247.82 735.13 247.82 735.13 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.67"
					y1="237.21"
					x2="735.13"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.67"
					y1="247.82"
					x2="738.67"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.13"
					y1="247.82"
					x2="738.67"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.13"
					y1="237.21"
					x2="735.13"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="641.28 237.21 644.82 237.21 644.82 247.82 641.28 247.82 641.28 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="644.82"
					y1="237.21"
					x2="641.28"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.82"
					y1="247.82"
					x2="644.82"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.28"
					y1="247.82"
					x2="644.82"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.28"
					y1="237.21"
					x2="641.28"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="506.13 236.52 475.87 236.52 475.87 240.34 506.13 240.34 506.13 236.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="474.48 236.17 507.52 236.17 507.52 236.52 474.48 236.52 474.48 236.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="474.48"
					y1="236.17"
					x2="507.52"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.52"
					y1="236.17"
					x2="507.52"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.52"
					y1="236.52"
					x2="474.48"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.48"
					y1="236.52"
					x2="474.48"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.13"
					y1="240.34"
					x2="475.87"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.87"
					y1="236.52"
					x2="506.13"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="509.26 240.34 506.13 240.34 506.13 236.52 509.26 236.52 509.26 240.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="509.26"
					y1="240.34"
					x2="506.13"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.13"
					y1="240.34"
					x2="506.13"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.13"
					y1="236.52"
					x2="509.26"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.26"
					y1="236.52"
					x2="509.26"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="472.74 236.52 475.87 236.52 475.87 240.34 472.74 240.34 472.74 236.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="472.74"
					y1="236.52"
					x2="475.87"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.87"
					y1="236.52"
					x2="475.87"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.87"
					y1="240.34"
					x2="472.74"
					y2="240.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.74"
					y1="240.34"
					x2="472.74"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.13"
					y1="237.21"
					x2="475.87"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="510.65 240 509.26 240 509.26 236.52 507.52 236.52 507.52 236.17 510.65 236.17 510.65 240"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.65"
					y1="240"
					x2="509.26"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.26"
					y1="240"
					x2="509.26"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.26"
					y1="236.52"
					x2="507.52"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.52"
					y1="236.52"
					x2="507.52"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.52"
					y1="236.17"
					x2="510.65"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.65"
					y1="236.17"
					x2="510.65"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="471.35 236.17 474.48 236.17 474.48 236.52 472.74 236.52 472.74 240 471.35 240 471.35 236.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="471.35"
					y1="236.17"
					x2="474.48"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.48"
					y1="236.17"
					x2="474.48"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.48"
					y1="236.52"
					x2="472.74"
					y2="236.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.74"
					y1="236.52"
					x2="472.74"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.74"
					y1="240"
					x2="471.35"
					y2="240"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.35"
					y1="240"
					x2="471.35"
					y2="236.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="469.58 237.21 469.58 238.98 375.73 238.98 375.73 237.21 469.58 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="469.58"
					y1="237.21"
					x2="469.58"
					y2="238.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.58"
					y1="238.98"
					x2="375.73"
					y2="238.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.73"
					y1="238.98"
					x2="375.73"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.73"
					y1="237.21"
					x2="469.58"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="510.65 237.21 514.19 237.21 514.19 247.82 510.65 247.82 510.65 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="514.19"
					y1="237.21"
					x2="510.65"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.19"
					y1="247.82"
					x2="514.19"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.65"
					y1="247.82"
					x2="514.19"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.65"
					y1="237.21"
					x2="510.65"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="467.81 237.21 471.35 237.21 471.35 247.82 467.81 247.82 467.81 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="471.35"
					y1="237.21"
					x2="467.81"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.35"
					y1="247.82"
					x2="471.35"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.81"
					y1="247.82"
					x2="471.35"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.81"
					y1="237.21"
					x2="467.81"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="373.96 237.21 377.5 237.21 377.5 247.82 373.96 247.82 373.96 237.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="377.5"
					y1="237.21"
					x2="373.96"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.5"
					y1="247.82"
					x2="377.5"
					y2="237.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.96"
					y1="247.82"
					x2="377.5"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.96"
					y1="237.21"
					x2="373.96"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="268 541.24 223.67 541.24 223.67 544.72 268 544.72 268 541.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="268"
					y1="544.72"
					x2="268"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.67"
					y1="544.72"
					x2="268"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.67"
					y1="541.24"
					x2="223.67"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268"
					y1="541.24"
					x2="223.67"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268"
					y1="544.02"
					x2="223.67"
					y2="544.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268"
					y1="544.72"
					x2="223.67"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268"
					y1="541.24"
					x2="223.67"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.35 541.24 268 541.24 268 544.72 276.35 544.72 276.35 541.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.35"
					y1="544.72"
					x2="276.35"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268"
					y1="544.72"
					x2="276.35"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268"
					y1="541.24"
					x2="268"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.35"
					y1="541.24"
					x2="268"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="223.67 541.24 215.32 541.24 215.32 544.72 223.67 544.72 223.67 541.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="223.67"
					y1="544.72"
					x2="223.67"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.32"
					y1="544.72"
					x2="223.67"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.32"
					y1="541.24"
					x2="215.32"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.67"
					y1="541.24"
					x2="215.32"
					y2="541.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="280.17 546.11 280.17 542.98 279.83 542.98 279.83 544.72 276.35 544.72 276.35 546.11 280.17 546.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.35"
					y1="546.11"
					x2="280.17"
					y2="546.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.35"
					y1="544.72"
					x2="276.35"
					y2="546.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.83"
					y1="544.72"
					x2="276.35"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.83"
					y1="542.98"
					x2="279.83"
					y2="544.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.17"
					y1="542.98"
					x2="279.83"
					y2="542.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.17"
					y1="546.11"
					x2="280.17"
					y2="542.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.35 482.3 276.35 483.69 279.83 483.69 279.83 485.43 280.17 485.43 280.17 482.3 276.35 482.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="280.17"
					y1="482.3"
					x2="276.35"
					y2="482.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.17"
					y1="485.43"
					x2="280.17"
					y2="482.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.83"
					y1="485.43"
					x2="280.17"
					y2="485.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.83"
					y1="483.69"
					x2="279.83"
					y2="485.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.35"
					y1="483.69"
					x2="279.83"
					y2="483.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.35"
					y1="482.3"
					x2="276.35"
					y2="483.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 480.53 278.81 480.53 278.81 412.29 277.04 412.29 277.04 480.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.04"
					y1="412.29"
					x2="277.04"
					y2="480.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.81"
					y1="412.29"
					x2="277.04"
					y2="412.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.81"
					y1="480.53"
					x2="278.81"
					y2="412.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="480.53"
					x2="278.81"
					y2="480.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 412.29 278.81 412.29 278.81 349.42 277.04 349.42 277.04 412.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.04"
					y1="349.42"
					x2="277.04"
					y2="412.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.81"
					y1="349.42"
					x2="277.04"
					y2="349.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.81"
					y1="412.29"
					x2="278.81"
					y2="349.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="412.29"
					x2="278.81"
					y2="412.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 349.42 278.81 349.42 278.81 285.29 277.04 285.29 277.04 349.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.04"
					y1="285.29"
					x2="277.04"
					y2="349.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.81"
					y1="285.29"
					x2="277.04"
					y2="285.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.81"
					y1="349.42"
					x2="278.81"
					y2="285.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="349.42"
					x2="278.81"
					y2="349.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 546.11 287.65 546.11 287.65 549.64 277.04 549.64 277.04 546.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.65"
					y1="546.11"
					x2="277.04"
					y2="546.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="549.64"
					x2="287.65"
					y2="546.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="549.64"
					x2="287.65"
					y2="549.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="546.11"
					x2="277.04"
					y2="549.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 478.76 287.65 478.76 287.65 482.3 277.04 482.3 277.04 478.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.65"
					y1="478.76"
					x2="277.04"
					y2="478.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="482.3"
					x2="287.65"
					y2="478.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="482.3"
					x2="287.65"
					y2="482.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="478.76"
					x2="277.04"
					y2="482.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 410.52 287.65 410.52 287.65 414.06 277.04 414.06 277.04 410.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.65"
					y1="410.52"
					x2="277.04"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="414.06"
					x2="287.65"
					y2="410.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="414.06"
					x2="287.65"
					y2="414.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="410.52"
					x2="277.04"
					y2="414.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 283.52 287.65 283.52 287.65 287.05 277.04 287.05 277.04 283.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.65"
					y1="283.52"
					x2="277.04"
					y2="283.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="287.05"
					x2="287.65"
					y2="283.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="287.05"
					x2="287.65"
					y2="287.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="283.52"
					x2="277.04"
					y2="287.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.04 347.65 287.65 347.65 287.65 351.19 277.04 351.19 277.04 347.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.65"
					y1="347.65"
					x2="277.04"
					y2="347.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="351.19"
					x2="287.65"
					y2="347.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="351.19"
					x2="287.65"
					y2="351.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.04"
					y1="347.65"
					x2="277.04"
					y2="351.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="198.23 641.85 198.23 643.62 246.75 643.62 246.75 641.85 198.23 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="246.75"
					y1="641.85"
					x2="198.23"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.75"
					y1="643.62"
					x2="246.75"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.23"
					y1="643.62"
					x2="246.75"
					y2="643.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.23"
					y1="641.85"
					x2="198.23"
					y2="643.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="149.63 641.85 149.63 643.62 198.23 643.62 198.23 641.85 149.63 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="198.23"
					y1="641.85"
					x2="149.63"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.23"
					y1="643.62"
					x2="198.23"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.63"
					y1="643.62"
					x2="198.23"
					y2="643.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.63"
					y1="641.85"
					x2="149.63"
					y2="643.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="100.69 641.85 100.69 643.62 149.63 643.62 149.63 641.85 100.69 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="149.63"
					y1="641.85"
					x2="100.69"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.63"
					y1="643.62"
					x2="149.63"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.69"
					y1="643.62"
					x2="149.63"
					y2="643.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.69"
					y1="641.85"
					x2="100.69"
					y2="643.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="200 641.85 200 652.46 196.47 652.46 196.47 641.85 200 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="200"
					y1="652.46"
					x2="200"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.47"
					y1="652.46"
					x2="200"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.47"
					y1="641.85"
					x2="196.47"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200"
					y1="641.85"
					x2="196.47"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="98.92 641.85 102.46 641.85 102.46 652.46 98.92 652.46 98.92 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="102.46"
					y1="641.85"
					x2="98.92"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.46"
					y1="652.46"
					x2="102.46"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.92"
					y1="652.46"
					x2="102.46"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.92"
					y1="641.85"
					x2="98.92"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="151.4 641.85 151.4 652.46 147.86 652.46 147.86 641.85 151.4 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="151.4"
					y1="652.46"
					x2="151.4"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.86"
					y1="652.46"
					x2="151.4"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.86"
					y1="641.85"
					x2="147.86"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.4"
					y1="641.85"
					x2="147.86"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="248.52 641.85 248.52 652.46 244.99 652.46 244.99 641.85 248.52 641.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="248.52"
					y1="652.46"
					x2="248.52"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.99"
					y1="652.46"
					x2="248.52"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.99"
					y1="641.85"
					x2="244.99"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.52"
					y1="641.85"
					x2="244.99"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.91"
					y1="704.84"
					x2="806.56"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="806.56"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="803.91"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="704.84"
					x2="734.1"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="734.1"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="736.75"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="733.46"
					y1="704.84"
					x2="736.75"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="690.7"
					x2="803.91"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="719.32"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="737.63 705.72 737.63 704.84 734.1 704.84 734.1 705.72 737.63 705.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="803.02 704.84 803.02 705.72 806.56 705.72 806.56 704.84 803.02 704.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="737.63 690.7 737.63 689.82 734.1 689.82 734.1 690.7 737.63 690.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="803.02 689.82 803.02 690.7 806.56 690.7 806.56 689.82 803.02 689.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="737.63"
					y1="705.72"
					x2="734.1"
					y2="705.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="705.72"
					x2="734.1"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="704.84"
					x2="737.63"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.63"
					y1="704.84"
					x2="737.63"
					y2="705.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.02"
					y1="704.84"
					x2="806.56"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.56"
					y1="704.84"
					x2="806.56"
					y2="705.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.56"
					y1="705.72"
					x2="803.02"
					y2="705.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.02"
					y1="705.72"
					x2="803.02"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.63"
					y1="690.7"
					x2="734.1"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="690.7"
					x2="734.1"
					y2="689.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.1"
					y1="689.82"
					x2="737.63"
					y2="689.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.63"
					y1="689.82"
					x2="737.63"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.02"
					y1="689.82"
					x2="806.56"
					y2="689.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.56"
					y1="689.82"
					x2="806.56"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.56"
					y1="690.7"
					x2="803.02"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.02"
					y1="690.7"
					x2="803.02"
					y2="689.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.52 704.84 738.52 690.7 737.19 690.7 737.19 704.84 738.52 704.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="803.47 704.84 803.47 690.7 802.14 690.7 802.14 704.84 803.47 704.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="757.15 645.71 754.96 647.9 799.95 692.89 802.14 690.7 757.15 645.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="737.19"
					y1="690.7"
					x2="736.75"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="704.84"
					x2="736.75"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="736.75"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.47"
					y1="690.7"
					x2="803.91"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.47"
					y1="704.84"
					x2="803.91"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="803.91"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.52"
					y1="704.84"
					x2="738.52"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.52"
					y1="690.7"
					x2="737.19"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="690.7"
					x2="737.19"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.19"
					y1="704.84"
					x2="738.52"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.47"
					y1="704.84"
					x2="803.47"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.47"
					y1="690.7"
					x2="802.14"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.14"
					y1="690.7"
					x2="802.14"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.14"
					y1="704.84"
					x2="803.47"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.15"
					y1="645.71"
					x2="754.96"
					y2="647.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.96"
					y1="647.9"
					x2="799.95"
					y2="692.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.95"
					y1="692.89"
					x2="802.14"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.14"
					y1="690.7"
					x2="757.15"
					y2="645.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="736.75"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="736.75"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="734.1"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="690.7"
					x2="734.1"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="704.84"
					x2="734.1"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="736.75"
					y1="704.84"
					x2="734.1"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="803.91"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="803.91"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="806.56"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="690.7"
					x2="806.56"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="704.84"
					x2="806.56"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="803.91"
					y1="704.84"
					x2="806.56"
					y2="704.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="935.86"
					y1="579.38"
					x2="935.86"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="920.76"
					y1="579.38"
					x2="935.86"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="920.76"
					y1="524.96"
					x2="920.76"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="822.67"
					y1="524.96"
					x2="920.76"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="781.51"
					y1="233.68"
					x2="781.51"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="781.51"
					y1="247.82"
					x2="787.53"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="273.51"
					y1="283.52"
					x2="287.65"
					y2="283.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="248.52"
					y1="638.32"
					x2="248.52"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="50"
					y1="709.47"
					x2="64.14"
					y2="709.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="488.66"
					y1="925.41"
					x2="383.2"
					y2="925.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="502.05"
					y1="830.38"
					x2="502.05"
					y2="869.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="773.15"
					y1="516.13"
					x2="680"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="524.96"
					x2="822.67"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="577.77"
					y1="507.11"
					x2="577.77"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="586.6"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="577.77"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="577.77"
					y1="450.55"
					x2="577.77"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="586.6"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="577.77"
					y2="450.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="516.13"
					x2="586.6"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="576.89 451.43 577.77 451.43 577.77 447.9 576.89 447.9 576.89 451.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="577.77 506.22 576.89 506.22 576.89 509.76 577.77 509.76 577.77 506.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="586.6 451.43 587.49 451.43 587.49 447.9 586.6 447.9 586.6 451.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="587.49 506.22 586.6 506.22 586.6 509.76 587.49 509.76 587.49 506.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="576.89"
					y1="451.43"
					x2="576.89"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.89"
					y1="447.9"
					x2="577.77"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="447.9"
					x2="577.77"
					y2="451.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="451.43"
					x2="576.89"
					y2="451.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="506.22"
					x2="577.77"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="509.76"
					x2="576.89"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.89"
					y1="509.76"
					x2="576.89"
					y2="506.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.89"
					y1="506.22"
					x2="577.77"
					y2="506.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="451.43"
					x2="586.6"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="447.9"
					x2="587.49"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.49"
					y1="447.9"
					x2="587.49"
					y2="451.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.49"
					y1="451.43"
					x2="586.6"
					y2="451.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.49"
					y1="506.22"
					x2="587.49"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.49"
					y1="509.76"
					x2="586.6"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="509.76"
					x2="586.6"
					y2="506.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="506.22"
					x2="587.49"
					y2="506.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="577.77 452.32 586.6 452.32 586.6 450.99 577.77 450.99 577.77 452.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="577.77 506.66 586.6 506.66 586.6 505.34 577.77 505.34 577.77 506.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="624.1 467.85 621.91 465.66 584.42 503.15 586.6 505.34 624.1 467.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="586.6"
					y1="450.99"
					x2="586.6"
					y2="450.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="450.99"
					x2="577.77"
					y2="450.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="577.77"
					y2="450.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="506.66"
					x2="586.6"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="506.66"
					x2="577.77"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="577.77"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="452.32"
					x2="586.6"
					y2="452.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="452.32"
					x2="586.6"
					y2="450.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="450.99"
					x2="577.77"
					y2="450.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="450.99"
					x2="577.77"
					y2="452.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="506.66"
					x2="586.6"
					y2="506.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="506.66"
					x2="586.6"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="505.34"
					x2="577.77"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.77"
					y1="505.34"
					x2="577.77"
					y2="506.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.1"
					y1="467.85"
					x2="621.91"
					y2="465.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.91"
					y1="465.66"
					x2="584.42"
					y2="503.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.42"
					y1="503.15"
					x2="586.6"
					y2="505.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="505.34"
					x2="624.1"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="577.77"
					y2="450.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="577.77"
					y2="450.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="586.6"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="450.55"
					x2="586.6"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="577.77"
					y1="450.55"
					x2="577.77"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="577.77"
					y1="450.55"
					x2="577.77"
					y2="447.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="577.77"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="577.77"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="586.6"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="586.6"
					y1="507.11"
					x2="586.6"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="577.77"
					y1="507.11"
					x2="577.77"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="577.77"
					y1="507.11"
					x2="577.77"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="579.81"
					x2="765.26"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="581.58"
					x2="763.06"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="588.65"
					x2="765.26"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="588.65"
					x2="763.06"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="579.81"
					x2="689.27"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="581.58"
					x2="691.48"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="588.65"
					x2="689.27"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="588.65"
					x2="691.48"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="579.81"
					x2="763.06"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="579.81"
					x2="650.96"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="692.8 581.58 692.8 579.81 691.92 579.81 691.92 581.58 692.8 581.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="692.8 578.93 689.27 578.93 689.27 579.81 692.8 579.81 692.8 578.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="762.61 581.58 762.61 579.81 761.73 579.81 761.73 581.58 762.61 581.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="761.73 579.81 765.26 579.81 765.26 578.93 761.73 578.93 761.73 579.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="692.8 588.65 689.27 588.65 689.27 590.86 692.8 590.86 692.8 588.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="761.73 590.86 765.26 590.86 765.26 588.65 761.73 588.65 761.73 590.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.8"
					y1="581.58"
					x2="692.8"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.8"
					y1="579.81"
					x2="691.92"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.92"
					y1="579.81"
					x2="691.92"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.92"
					y1="581.58"
					x2="692.8"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.8"
					y1="578.93"
					x2="689.27"
					y2="578.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.27"
					y1="578.93"
					x2="689.27"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.27"
					y1="579.81"
					x2="692.8"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.8"
					y1="579.81"
					x2="692.8"
					y2="578.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.61"
					y1="581.58"
					x2="762.61"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.61"
					y1="579.81"
					x2="761.73"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="579.81"
					x2="761.73"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="581.58"
					x2="762.61"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="579.81"
					x2="765.26"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.26"
					y1="579.81"
					x2="765.26"
					y2="578.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.26"
					y1="578.93"
					x2="761.73"
					y2="578.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="578.93"
					x2="761.73"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.8"
					y1="588.65"
					x2="689.27"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.27"
					y1="588.65"
					x2="689.27"
					y2="590.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.27"
					y1="590.86"
					x2="692.8"
					y2="590.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.8"
					y1="590.86"
					x2="692.8"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="590.86"
					x2="765.26"
					y2="590.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.26"
					y1="590.86"
					x2="765.26"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.26"
					y1="588.65"
					x2="761.73"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.73"
					y1="588.65"
					x2="761.73"
					y2="590.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="695.45 581.58 691.92 581.58 691.92 588.65 695.45 588.65 695.45 581.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="762.61 581.58 759.08 581.58 759.08 588.65 762.61 588.65 762.61 581.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="725.5 588.65 759.08 588.65 759.08 585.56 725.5 585.56 725.5 588.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="716.66 585.56 750.24 585.56 750.24 582.47 716.66 582.47 716.66 585.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="691.92"
					y1="588.65"
					x2="691.48"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.92"
					y1="581.58"
					x2="691.48"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.48"
					y1="588.65"
					x2="691.48"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.61"
					y1="588.65"
					x2="763.06"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.61"
					y1="581.58"
					x2="763.06"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.06"
					y1="588.65"
					x2="763.06"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.45"
					y1="581.58"
					x2="695.45"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.45"
					y1="588.65"
					x2="691.92"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.92"
					y1="588.65"
					x2="691.92"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.92"
					y1="581.58"
					x2="695.45"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.61"
					y1="581.58"
					x2="762.61"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.61"
					y1="588.65"
					x2="759.08"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.08"
					y1="588.65"
					x2="759.08"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.08"
					y1="581.58"
					x2="762.61"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.5"
					y1="588.65"
					x2="725.5"
					y2="585.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.5"
					y1="585.56"
					x2="759.08"
					y2="585.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.08"
					y1="585.56"
					x2="759.08"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.08"
					y1="588.65"
					x2="725.5"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.66"
					y1="585.56"
					x2="716.66"
					y2="582.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.66"
					y1="582.47"
					x2="750.24"
					y2="582.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.24"
					y1="582.47"
					x2="750.24"
					y2="585.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.24"
					y1="585.56"
					x2="716.66"
					y2="585.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.48"
					y1="588.65"
					x2="691.48"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="588.65"
					x2="691.48"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="581.58"
					x2="691.48"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="588.65"
					x2="689.27"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="581.58"
					x2="691.48"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="579.81"
					x2="689.27"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="691.48"
					y1="579.81"
					x2="689.27"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="588.65"
					x2="763.06"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="588.65"
					x2="763.06"
					y2="581.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="581.58"
					x2="763.06"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="588.65"
					x2="765.26"
					y2="588.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="581.58"
					x2="763.06"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="579.81"
					x2="765.26"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="763.06"
					y1="579.81"
					x2="765.26"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="686.78"
					x2="808.17"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="817"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="808.17"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="630.22"
					x2="808.17"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="817"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="808.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="690.7"
					x2="817"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="524.96"
					x2="808.17"
					y2="579.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="686.78"
					x2="808.17"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="807.28 631.1 808.17 631.1 808.17 627.57 807.28 627.57 807.28 631.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="808.17 685.89 807.28 685.89 807.28 689.43 808.17 689.43 808.17 685.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="817 631.1 817.89 631.1 817.89 627.57 817 627.57 817 631.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="817.89 685.89 817 685.89 817 689.43 817.89 689.43 817.89 685.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="807.28"
					y1="631.1"
					x2="807.28"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.28"
					y1="627.57"
					x2="808.17"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="627.57"
					x2="808.17"
					y2="631.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="631.1"
					x2="807.28"
					y2="631.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="685.89"
					x2="808.17"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="689.43"
					x2="807.28"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.28"
					y1="689.43"
					x2="807.28"
					y2="685.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.28"
					y1="685.89"
					x2="808.17"
					y2="685.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="631.1"
					x2="817"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="627.57"
					x2="817.89"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.89"
					y1="627.57"
					x2="817.89"
					y2="631.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.89"
					y1="631.1"
					x2="817"
					y2="631.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.89"
					y1="685.89"
					x2="817.89"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.89"
					y1="689.43"
					x2="817"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="689.43"
					x2="817"
					y2="685.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="685.89"
					x2="817.89"
					y2="685.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="808.17 631.99 817 631.99 817 630.66 808.17 630.66 808.17 631.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="808.17 686.34 817 686.34 817 685.01 808.17 685.01 808.17 686.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="854.49 647.52 852.31 645.33 814.81 682.82 817 685.01 854.49 647.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="817"
					y1="630.66"
					x2="817"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="630.66"
					x2="808.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="808.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="686.34"
					x2="817"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="686.34"
					x2="808.17"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="808.17"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="631.99"
					x2="817"
					y2="631.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="631.99"
					x2="817"
					y2="630.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="630.66"
					x2="808.17"
					y2="630.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="630.66"
					x2="808.17"
					y2="631.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="686.34"
					x2="817"
					y2="686.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="686.34"
					x2="817"
					y2="685.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="685.01"
					x2="808.17"
					y2="685.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.17"
					y1="685.01"
					x2="808.17"
					y2="686.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.49"
					y1="647.52"
					x2="852.31"
					y2="645.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.31"
					y1="645.33"
					x2="814.81"
					y2="682.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.81"
					y1="682.82"
					x2="817"
					y2="685.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="685.01"
					x2="854.49"
					y2="647.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="808.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="808.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="817"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="630.22"
					x2="817"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="630.22"
					x2="808.17"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="630.22"
					x2="808.17"
					y2="627.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="808.17"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="808.17"
					y2="686.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="817"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="817"
					y1="686.78"
					x2="817"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="686.78"
					x2="808.17"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="808.17"
					y1="686.78"
					x2="808.17"
					y2="689.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="680"
					y1="516.13"
					x2="680"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="671.16"
					y1="466.34"
					x2="671.16"
					y2="516.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="475.18"
					x2="754.81"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="754.81"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="752.16"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="475.18"
					x2="692.95"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="692.95"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="695.6"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="680"
					y1="475.18"
					x2="695.6"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="475.18"
					x2="773.15"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="671.16"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="696.49 476.06 696.49 475.18 692.95 475.18 692.95 476.06 696.49 476.06"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.28 475.18 751.28 476.06 754.81 476.06 754.81 475.18 751.28 475.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="696.49 466.34 696.49 465.46 692.95 465.46 692.95 466.34 696.49 466.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.28 465.46 751.28 466.34 754.81 466.34 754.81 465.46 751.28 465.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="696.49"
					y1="476.06"
					x2="692.95"
					y2="476.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.95"
					y1="476.06"
					x2="692.95"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.95"
					y1="475.18"
					x2="696.49"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.49"
					y1="475.18"
					x2="696.49"
					y2="476.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.28"
					y1="475.18"
					x2="754.81"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.81"
					y1="475.18"
					x2="754.81"
					y2="476.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.81"
					y1="476.06"
					x2="751.28"
					y2="476.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.28"
					y1="476.06"
					x2="751.28"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.49"
					y1="466.34"
					x2="692.95"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.95"
					y1="466.34"
					x2="692.95"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.95"
					y1="465.46"
					x2="696.49"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.49"
					y1="465.46"
					x2="696.49"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.28"
					y1="465.46"
					x2="754.81"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.81"
					y1="465.46"
					x2="754.81"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.81"
					y1="466.34"
					x2="751.28"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.28"
					y1="466.34"
					x2="751.28"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="697.37 475.18 697.37 466.34 696.04 466.34 696.04 475.18 697.37 475.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.72 475.18 751.72 466.34 750.39 466.34 750.39 475.18 751.72 475.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="712.9 428.85 710.71 431.03 748.21 468.53 750.39 466.34 712.9 428.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="696.04"
					y1="466.34"
					x2="695.6"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.04"
					y1="475.18"
					x2="695.6"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="695.6"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.72"
					y1="466.34"
					x2="752.16"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.72"
					y1="475.18"
					x2="752.16"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="752.16"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.37"
					y1="475.18"
					x2="697.37"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.37"
					y1="466.34"
					x2="696.04"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.04"
					y1="466.34"
					x2="696.04"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.04"
					y1="475.18"
					x2="697.37"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.72"
					y1="475.18"
					x2="751.72"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.72"
					y1="466.34"
					x2="750.39"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.39"
					y1="466.34"
					x2="750.39"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.39"
					y1="475.18"
					x2="751.72"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.9"
					y1="428.85"
					x2="710.71"
					y2="431.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.71"
					y1="431.03"
					x2="748.21"
					y2="468.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.21"
					y1="468.53"
					x2="750.39"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.39"
					y1="466.34"
					x2="712.9"
					y2="428.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="695.6"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="695.6"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="692.95"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="466.34"
					x2="692.95"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="475.18"
					x2="692.95"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="695.6"
					y1="475.18"
					x2="692.95"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="752.16"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="752.16"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="754.81"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="466.34"
					x2="754.81"
					y2="466.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="475.18"
					x2="754.81"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="752.16"
					y1="475.18"
					x2="754.81"
					y2="475.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="787.53"
					y1="247.82"
					x2="787.53"
					y2="259.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="772.32"
					x2="374.36"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="383.2"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="374.36"
					y2="772.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="828.88"
					x2="374.36"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="383.2"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="374.36"
					y2="828.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="701.35"
					x2="374.36"
					y2="698.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="747.3"
					x2="383.2"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="374.36"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="383.2"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="751.12"
					x2="383.2"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="697.52"
					x2="374.36"
					y2="701.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="373.48 828 373.48 831.53 374.36 831.53 374.36 828 373.48 828"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="374.36 773.21 374.36 769.67 373.48 769.67 373.48 773.21 374.36 773.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="383.2 828 383.2 831.53 384.09 831.53 384.09 828 383.2 828"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="384.09 773.21 384.09 769.67 383.2 769.67 383.2 773.21 384.09 773.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="373.48"
					y1="828"
					x2="373.48"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="831.53"
					x2="374.36"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="831.53"
					x2="374.36"
					y2="828"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="828"
					x2="373.48"
					y2="828"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="773.21"
					x2="374.36"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="769.67"
					x2="373.48"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="769.67"
					x2="373.48"
					y2="773.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="773.21"
					x2="374.36"
					y2="773.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="828"
					x2="383.2"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="831.53"
					x2="384.09"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.09"
					y1="831.53"
					x2="384.09"
					y2="828"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.09"
					y1="828"
					x2="383.2"
					y2="828"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.09"
					y1="773.21"
					x2="384.09"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.09"
					y1="769.67"
					x2="383.2"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="769.67"
					x2="383.2"
					y2="773.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="773.21"
					x2="384.09"
					y2="773.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="374.36 827.11 374.36 828.44 383.2 828.44 383.2 827.11 374.36 827.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="374.36 772.77 374.36 774.09 383.2 774.09 383.2 772.77 374.36 772.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="420.69 811.58 383.2 774.09 381.02 776.28 418.51 813.77 420.69 811.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="383.2"
					y1="828.44"
					x2="383.2"
					y2="828.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="828.44"
					x2="374.36"
					y2="828.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="374.36"
					y2="828.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="772.77"
					x2="383.2"
					y2="772.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="772.77"
					x2="374.36"
					y2="772.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="374.36"
					y2="772.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="827.11"
					x2="383.2"
					y2="827.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="827.11"
					x2="383.2"
					y2="828.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="828.44"
					x2="374.36"
					y2="828.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="828.44"
					x2="374.36"
					y2="827.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="772.77"
					x2="383.2"
					y2="772.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="772.77"
					x2="383.2"
					y2="774.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="774.09"
					x2="374.36"
					y2="774.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="774.09"
					x2="374.36"
					y2="772.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.69"
					y1="811.58"
					x2="418.51"
					y2="813.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.51"
					y1="813.77"
					x2="381.02"
					y2="776.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.02"
					y1="776.28"
					x2="383.2"
					y2="774.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="774.09"
					x2="420.69"
					y2="811.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="374.36"
					y2="828.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="374.36"
					y2="828.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="383.2"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="828.88"
					x2="383.2"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="828.88"
					x2="374.36"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="828.88"
					x2="374.36"
					y2="831.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="374.36"
					y2="772.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="374.36"
					y2="772.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="383.2"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="772.32"
					x2="383.2"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="772.32"
					x2="374.36"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="772.32"
					x2="374.36"
					y2="769.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="384.09 746.41 383.2 746.41 383.2 749.95 384.09 749.95 384.09 746.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="374.36 746.41 373.48 746.41 373.48 749.95 374.36 749.95 374.36 746.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="373.48 702.23 374.36 702.23 374.36 698.69 373.48 698.69 373.48 702.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="384.09"
					y1="746.41"
					x2="384.09"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.09"
					y1="749.95"
					x2="383.2"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="749.95"
					x2="383.2"
					y2="746.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="746.41"
					x2="384.09"
					y2="746.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="746.41"
					x2="374.36"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="749.95"
					x2="373.48"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="749.95"
					x2="373.48"
					y2="746.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="746.41"
					x2="374.36"
					y2="746.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="702.23"
					x2="373.48"
					y2="698.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.48"
					y1="698.69"
					x2="374.36"
					y2="698.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="698.69"
					x2="374.36"
					y2="702.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="702.23"
					x2="373.48"
					y2="702.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="383.2 745.53 374.36 745.53 374.36 746.86 383.2 746.86 383.2 745.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="344.37 733.11 346.56 735.29 376.55 705.3 374.36 703.11 344.37 733.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="374.36"
					y1="746.86"
					x2="374.36"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="746.86"
					x2="383.2"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="383.2"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="701.79"
					x2="374.36"
					y2="701.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="745.53"
					x2="374.36"
					y2="745.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="745.53"
					x2="374.36"
					y2="746.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="746.86"
					x2="383.2"
					y2="746.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="746.86"
					x2="383.2"
					y2="745.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="701.79"
					x2="374.36"
					y2="703.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.37"
					y1="733.11"
					x2="346.56"
					y2="735.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.56"
					y1="735.29"
					x2="376.55"
					y2="705.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.55"
					y1="705.3"
					x2="374.36"
					y2="703.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="703.11"
					x2="344.37"
					y2="733.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="383.2"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="383.2"
					y2="747.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="374.36"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="747.3"
					x2="374.36"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="747.3"
					x2="383.2"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="383.2"
					y1="747.3"
					x2="383.2"
					y2="749.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="701.35"
					x2="374.36"
					y2="698.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="374.36"
					y1="701.35"
					x2="374.36"
					y2="698.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="688.68"
					x2="370.92"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="370.92"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="368.27"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="688.68"
					x2="309.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="309.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="311.72"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="697.52"
					x2="493.85"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="493.85"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="491.19"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="697.52"
					x2="439.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="439.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="441.71"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="374.36"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="436.78"
					y1="697.52"
					x2="441.71"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="697.52"
					x2="496.13"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="312.6 687.8 309.06 687.8 309.06 688.68 312.6 688.68 312.6 687.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="367.39 688.68 370.92 688.68 370.92 687.8 367.39 687.8 367.39 688.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="312.6 697.52 309.06 697.52 309.06 698.4 312.6 698.4 312.6 697.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="367.39 698.4 370.92 698.4 370.92 697.52 367.39 697.52 367.39 698.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="312.6"
					y1="687.8"
					x2="309.06"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.06"
					y1="687.8"
					x2="309.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.06"
					y1="688.68"
					x2="312.6"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.6"
					y1="688.68"
					x2="312.6"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.39"
					y1="688.68"
					x2="370.92"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.92"
					y1="688.68"
					x2="370.92"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.92"
					y1="687.8"
					x2="367.39"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.39"
					y1="687.8"
					x2="367.39"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.6"
					y1="697.52"
					x2="309.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.06"
					y1="697.52"
					x2="309.06"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.06"
					y1="698.4"
					x2="312.6"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.6"
					y1="698.4"
					x2="312.6"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.39"
					y1="698.4"
					x2="370.92"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.92"
					y1="698.4"
					x2="370.92"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.92"
					y1="697.52"
					x2="367.39"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.39"
					y1="697.52"
					x2="367.39"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="313.48 688.68 312.16 688.68 312.16 697.52 313.48 697.52 313.48 688.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="367.83 688.68 366.51 688.68 366.51 697.52 367.83 697.52 367.83 688.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.01 735.01 366.51 697.52 364.32 695.33 326.83 732.82 329.01 735.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="312.16"
					y1="697.52"
					x2="311.72"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.16"
					y1="688.68"
					x2="311.72"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="311.72"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.83"
					y1="697.52"
					x2="368.27"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.83"
					y1="688.68"
					x2="368.27"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="368.27"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.48"
					y1="688.68"
					x2="313.48"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.48"
					y1="697.52"
					x2="312.16"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.16"
					y1="697.52"
					x2="312.16"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.16"
					y1="688.68"
					x2="313.48"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.83"
					y1="688.68"
					x2="367.83"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.83"
					y1="697.52"
					x2="366.51"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.51"
					y1="697.52"
					x2="366.51"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.51"
					y1="688.68"
					x2="367.83"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.01"
					y1="735.01"
					x2="326.83"
					y2="732.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.83"
					y1="732.82"
					x2="364.32"
					y2="695.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.32"
					y1="695.33"
					x2="366.51"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.51"
					y1="697.52"
					x2="329.01"
					y2="735.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="311.72"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="311.72"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="309.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="697.52"
					x2="309.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="688.68"
					x2="309.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="311.72"
					y1="688.68"
					x2="309.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="368.27"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="368.27"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="370.92"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="697.52"
					x2="370.92"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="688.68"
					x2="370.92"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="368.27"
					y1="688.68"
					x2="370.92"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="442.59 698.4 442.59 697.52 439.06 697.52 439.06 698.4 442.59 698.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="490.31 697.52 490.31 698.4 493.85 698.4 493.85 697.52 490.31 697.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="442.59 688.68 442.59 687.8 439.06 687.8 439.06 688.68 442.59 688.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="490.31 687.8 490.31 688.68 493.85 688.68 493.85 687.8 490.31 687.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="442.59"
					y1="698.4"
					x2="439.06"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.06"
					y1="698.4"
					x2="439.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.06"
					y1="697.52"
					x2="442.59"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.59"
					y1="697.52"
					x2="442.59"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="697.52"
					x2="493.85"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.85"
					y1="697.52"
					x2="493.85"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.85"
					y1="698.4"
					x2="490.31"
					y2="698.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="698.4"
					x2="490.31"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.59"
					y1="688.68"
					x2="439.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.06"
					y1="688.68"
					x2="439.06"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.06"
					y1="687.8"
					x2="442.59"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.59"
					y1="687.8"
					x2="442.59"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="687.8"
					x2="493.85"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.85"
					y1="687.8"
					x2="493.85"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.85"
					y1="688.68"
					x2="490.31"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="688.68"
					x2="490.31"
					y2="687.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="443.48 697.52 443.48 688.68 442.15 688.68 442.15 697.52 443.48 697.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="490.75 697.52 490.75 688.68 489.43 688.68 489.43 697.52 490.75 697.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="456.93 656.19 454.75 658.38 487.24 690.87 489.43 688.68 456.93 656.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="442.15"
					y1="688.68"
					x2="441.71"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.15"
					y1="697.52"
					x2="441.71"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="441.71"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.75"
					y1="688.68"
					x2="491.19"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.75"
					y1="697.52"
					x2="491.19"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="491.19"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.48"
					y1="697.52"
					x2="443.48"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.48"
					y1="688.68"
					x2="442.15"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.15"
					y1="688.68"
					x2="442.15"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.15"
					y1="697.52"
					x2="443.48"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.75"
					y1="697.52"
					x2="490.75"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.75"
					y1="688.68"
					x2="489.43"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.43"
					y1="688.68"
					x2="489.43"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.43"
					y1="697.52"
					x2="490.75"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.93"
					y1="656.19"
					x2="454.75"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.75"
					y1="658.38"
					x2="487.24"
					y2="690.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.24"
					y1="690.87"
					x2="489.43"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.43"
					y1="688.68"
					x2="456.93"
					y2="656.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="441.71"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="441.71"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="439.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="688.68"
					x2="439.06"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="697.52"
					x2="439.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="441.71"
					y1="697.52"
					x2="439.06"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="491.19"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="491.19"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="493.85"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="688.68"
					x2="493.85"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="697.52"
					x2="493.85"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="491.19"
					y1="697.52"
					x2="493.85"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="533.6"
					y1="743.58"
					x2="533.6"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="545.31"
					y1="743.58"
					x2="533.6"
					y2="743.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="502.05"
					y1="759.96"
					x2="502.05"
					y2="830.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="496.13"
					y1="751.12"
					x2="436.78"
					y2="751.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="436.78"
					y1="751.12"
					x2="436.78"
					y2="697.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="496.13"
					y1="697.52"
					x2="496.13"
					y2="751.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="650.96"
					y1="579.81"
					x2="650.96"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="502.05"
					y1="869.28"
					x2="488.66"
					y2="869.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="488.66"
					y1="869.28"
					x2="488.66"
					y2="925.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="836.82 233.68 833.28 233.68 833.28 63.99 836.82 60.45 836.82 233.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="836.82"
					y1="233.68"
					x2="836.82"
					y2="60.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.28"
					y1="63.99"
					x2="833.28"
					y2="233.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.28"
					y1="233.68"
					x2="836.82"
					y2="233.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="836.82 60.45 833.28 63.99 196.08 63.99 192.55 60.45 836.82 60.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="836.82"
					y1="60.45"
					x2="192.55"
					y2="60.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.08"
					y1="63.99"
					x2="833.28"
					y2="63.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="192.55 60.45 196.08 63.99 196.08 381.39 192.55 377.86 192.55 60.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="192.55"
					y1="60.45"
					x2="192.55"
					y2="377.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.08"
					y1="381.39"
					x2="196.08"
					y2="63.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="192.55 377.86 196.08 381.39 82.99 381.39 79.46 377.86 192.55 377.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="192.55"
					y1="377.86"
					x2="79.46"
					y2="377.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.99"
					y1="381.39"
					x2="196.08"
					y2="381.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="79.46 377.86 82.99 381.39 82.99 638.32 79.46 638.32 79.46 377.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="79.46"
					y1="377.86"
					x2="79.46"
					y2="638.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="79.46"
					y1="638.32"
					x2="82.99"
					y2="638.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.99"
					y1="638.32"
					x2="82.99"
					y2="381.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.92"
					y1="638.32"
					x2="50"
					y2="638.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="98.92"
					y1="652.46"
					x2="98.92"
					y2="638.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="287.65"
					y1="549.64"
					x2="273.51"
					y2="549.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="373.96"
					y1="247.82"
					x2="373.96"
					y2="233.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="514.19"
					y1="233.68"
					x2="514.19"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="64.14"
					y1="882.74"
					x2="64.14"
					y2="849.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<line
					x1="64.14"
					y1="849.69"
					x2="50"
					y2="849.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".36"
				/>
				<polyline
					points="595.66 688.68 595.66 743.58 533.6 743.58 533.6 688.68 595.66 688.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="595.66"
					y1="688.68"
					x2="595.66"
					y2="743.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.66"
					y1="743.58"
					x2="533.6"
					y2="743.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.6"
					y1="743.58"
					x2="533.6"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.6"
					y1="688.68"
					x2="595.66"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.24"
					y1="688.68"
					x2="591.24"
					y2="743.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="676.9 732.5 717.23 732.5 717.23 692.87 676.9 692.87 676.9 732.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="676.9"
					y1="692.87"
					x2="676.9"
					y2="694.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="696.99"
					x2="676.9"
					y2="701.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="703.78"
					x2="676.9"
					y2="708.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="710.56"
					x2="676.9"
					y2="714.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="717.35"
					x2="676.9"
					y2="721.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="724.14"
					x2="676.9"
					y2="728.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="730.93"
					x2="676.9"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="692.87"
					x2="715.3"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.76"
					y1="692.87"
					x2="708.51"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.97"
					y1="692.87"
					x2="701.73"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.19"
					y1="692.87"
					x2="694.94"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.4"
					y1="692.87"
					x2="688.15"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.61"
					y1="692.87"
					x2="681.37"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.82"
					y1="692.87"
					x2="676.9"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="732.5"
					x2="717.23"
					y2="730.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="728.38"
					x2="717.23"
					y2="724.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="721.6"
					x2="717.23"
					y2="717.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="714.81"
					x2="717.23"
					y2="710.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="708.02"
					x2="717.23"
					y2="703.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="701.23"
					x2="717.23"
					y2="696.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.23"
					y1="694.45"
					x2="717.23"
					y2="692.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="732.5"
					x2="678.82"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.37"
					y1="732.5"
					x2="685.61"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.15"
					y1="732.5"
					x2="692.4"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.94"
					y1="732.5"
					x2="699.19"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.73"
					y1="732.5"
					x2="705.97"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.51"
					y1="732.5"
					x2="712.76"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.3"
					y1="732.5"
					x2="717.23"
					y2="732.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="674.81 693.02 673.59 693.02 673.59 732.35 674.81 732.35 674.81 726.18 673.81 726.18 673.81 699.19 674.81 699.19 674.81 693.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="674.81"
					y1="699.19"
					x2="674.81"
					y2="693.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="673.81"
					y1="699.19"
					x2="674.81"
					y2="699.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="673.81"
					y1="726.18"
					x2="673.81"
					y2="699.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="674.81"
					y1="726.18"
					x2="673.81"
					y2="726.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="674.81"
					y1="732.35"
					x2="674.81"
					y2="726.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="673.59"
					y1="732.35"
					x2="674.81"
					y2="732.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="673.59"
					y1="693.02"
					x2="673.59"
					y2="732.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="674.81"
					y1="693.02"
					x2="673.59"
					y2="693.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<polyline
					points="674.81 691.48 674.81 733.89 676.9 733.89 676.9 691.48 674.81 691.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="676.9"
					y1="691.48"
					x2="674.81"
					y2="691.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="676.9"
					y1="733.89"
					x2="676.9"
					y2="691.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="674.81"
					y1="733.89"
					x2="676.9"
					y2="733.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="674.81"
					y1="691.48"
					x2="674.81"
					y2="733.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".26"
				/>
				<line
					x1="674.81"
					y1="732.35"
					x2="673.59"
					y2="732.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.59"
					y1="732.35"
					x2="673.59"
					y2="693.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.59"
					y1="693.02"
					x2="674.81"
					y2="693.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.81"
					y1="733.89"
					x2="674.81"
					y2="691.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.81"
					y1="699.19"
					x2="673.81"
					y2="699.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.81"
					y1="699.19"
					x2="673.81"
					y2="726.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.81"
					y1="726.18"
					x2="674.81"
					y2="726.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="733.89"
					x2="674.81"
					y2="733.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.81"
					y1="691.48"
					x2="676.9"
					y2="691.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="691.48"
					x2="676.9"
					y2="733.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="605.8 784.43 605.8 830.38 658.82 830.38 658.82 784.43 605.8 784.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="605.8"
					y1="784.43"
					x2="658.82"
					y2="784.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.8"
					y1="830.38"
					x2="658.82"
					y2="830.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.8"
					y1="828.99"
					x2="658.82"
					y2="828.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.8"
					y1="784.43"
					x2="605.8"
					y2="830.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.82"
					y1="784.43"
					x2="658.82"
					y2="830.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.28"
					y1="786.51"
					x2="655.34"
					y2="786.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.34"
					y1="786.51"
					x2="656.73"
					y2="787.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.73"
					y1="787.91"
					x2="656.73"
					y2="826.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.73"
					y1="826.9"
					x2="655.34"
					y2="828.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.34"
					y1="828.29"
					x2="609.28"
					y2="828.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.28"
					y1="828.29"
					x2="607.89"
					y2="826.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.89"
					y1="826.9"
					x2="607.89"
					y2="787.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.89"
					y1="787.91"
					x2="609.28"
					y2="786.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m626.01,795.92c0-3.84-3.11-6.96-6.95-6.96s-6.96,3.12-6.96,6.96,3.11,6.96,6.96,6.96,6.95-3.12,6.95-6.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m624.28,818.89c0-2.88-2.34-5.22-5.22-5.22s-5.22,2.34-5.22,5.22,2.34,5.22,5.22,5.22,5.22-2.34,5.22-5.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m650.78,795.92c0-2.88-2.34-5.22-5.22-5.22s-5.22,2.34-5.22,5.22,2.34,5.22,5.22,5.22,5.22-2.34,5.22-5.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m652.53,818.89c0-3.85-3.11-6.96-6.96-6.96s-6.96,3.11-6.96,6.96,3.12,6.96,6.96,6.96,6.96-3.12,6.96-6.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="681.98 739.67 681.98 783.7 682.39 784.68 683.37 785.09 712.84 785.09 713.83 784.68 714.23 783.7 714.23 739.67 713.83 738.69 712.84 738.28 683.37 738.28 682.39 738.69 681.98 739.67"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m681.98,739.67c0-.77.62-1.39,1.39-1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.84"
					y1="738.28"
					x2="683.37"
					y2="738.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m712.84,738.28c.77,0,1.39.62,1.39,1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.23"
					y1="783.7"
					x2="714.23"
					y2="739.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m714.23,783.7c0,.77-.62,1.39-1.39,1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.37"
					y1="785.09"
					x2="712.84"
					y2="785.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m683.37,785.09c-.77,0-1.39-.62-1.39-1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.98"
					y1="739.67"
					x2="681.98"
					y2="783.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.46"
					y1="743.16"
					x2="685.46"
					y2="780.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.85"
					y1="781.61"
					x2="705.88"
					y2="781.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.28"
					y1="780.22"
					x2="707.28"
					y2="743.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.88"
					y1="741.76"
					x2="686.85"
					y2="741.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.46"
					y1="743.16"
					x2="685.46"
					y2="743.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m686.85,781.61c-.77,0-1.39-.62-1.39-1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m707.28,780.22c0,.77-.62,1.39-1.39,1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m705.88,741.76c.77,0,1.39.62,1.39,1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m685.46,743.16c0-.77.62-1.39,1.39-1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m702.41,761.69c0-1.15-.94-2.09-2.09-2.09s-2.09.93-2.09,2.09.93,2.09,2.09,2.09,2.09-.94,2.09-2.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="698.38 761.06 697.93 761.25 697.75 761.69 697.94 762.13 698.38 762.31 712.15 762.31 712.59 762.13 712.77 761.69 712.59 761.24 712.15 761.06 698.38 761.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="712.15"
					y1="761.06"
					x2="698.38"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m712.15,761.06c.35,0,.63.28.63.63s-.28.63-.63.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.38"
					y1="762.31"
					x2="712.15"
					y2="762.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m698.38,762.31h0c-.35,0-.62-.28-.62-.63s.28-.62.62-.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="708.6 760.3 708.6 761.06 712.15 761.06 712.59 761.24 712.77 761.69 712.59 762.13 712.15 762.31 708.6 762.31 708.6 763.08 713.12 763.08 713.12 760.3 708.6 760.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="713.12"
					y1="760.3"
					x2="708.6"
					y2="760.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.12"
					y1="763.08"
					x2="713.12"
					y2="760.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.6"
					y1="763.08"
					x2="713.12"
					y2="763.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.6"
					y1="762.31"
					x2="708.6"
					y2="763.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.15"
					y1="762.31"
					x2="708.6"
					y2="762.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m712.15,761.06c.35,0,.63.28.63.63s-.28.63-.63.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.6"
					y1="761.06"
					x2="712.15"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.6"
					y1="760.3"
					x2="708.6"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.09 760.32 706.09 761.06 708.53 761.06 708.53 760.32 706.09 760.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.53"
					y1="760.32"
					x2="706.09"
					y2="760.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.53"
					y1="761.06"
					x2="708.53"
					y2="760.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.09"
					y1="761.06"
					x2="708.53"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.09"
					y1="760.32"
					x2="706.09"
					y2="761.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.09 763.06 708.53 763.06 708.53 762.31 706.09 762.31 706.09 763.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.09"
					y1="762.31"
					x2="706.09"
					y2="763.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.53"
					y1="762.31"
					x2="706.09"
					y2="762.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.53"
					y1="763.06"
					x2="708.53"
					y2="762.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.09"
					y1="763.06"
					x2="708.53"
					y2="763.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="920.76 524.96 920.76 579.38 817 579.38 817 524.96 920.76 524.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="920.76"
					y1="524.96"
					x2="920.76"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.76"
					y1="579.38"
					x2="817"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="579.38"
					x2="817"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817"
					y1="524.96"
					x2="920.76"
					y2="524.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="914.26 531.41 914.26 572.22 823.95 572.22 823.95 531.41 914.26 531.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="914.26"
					y1="531.41"
					x2="914.26"
					y2="572.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.26"
					y1="572.22"
					x2="823.95"
					y2="572.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.95"
					y1="572.22"
					x2="823.95"
					y2="531.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.95"
					y1="531.41"
					x2="914.26"
					y2="531.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="905.38 552.17 905.41 551.81 905.5 551.45 905.65 551.12 905.85 550.82 906.09 550.56 906.38 550.34 906.69 550.19 907.02 550.09 907.37 550.06 907.71 550.09 908.04 550.19 908.36 550.34 908.64 550.56 908.88 550.82 909.08 551.12 909.23 551.45 909.32 551.81 909.35 552.17 909.32 552.54 909.23 552.9 909.08 553.23 908.88 553.53 908.64 553.79 908.36 554 908.04 554.16 907.71 554.25 907.37 554.28 907.02 554.25 906.69 554.16 906.38 554 906.09 553.79 905.85 553.53 905.65 553.23 905.5 552.9 905.41 552.54 905.38 552.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="905.38"
					y1="552.17"
					x2="905.41"
					y2="551.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.41"
					y1="551.81"
					x2="905.5"
					y2="551.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.5"
					y1="551.45"
					x2="905.65"
					y2="551.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.65"
					y1="551.12"
					x2="905.85"
					y2="550.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.85"
					y1="550.82"
					x2="906.09"
					y2="550.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.09"
					y1="550.56"
					x2="906.38"
					y2="550.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.38"
					y1="550.34"
					x2="906.69"
					y2="550.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.69"
					y1="550.19"
					x2="907.02"
					y2="550.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.02"
					y1="550.09"
					x2="907.37"
					y2="550.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.37"
					y1="550.06"
					x2="907.71"
					y2="550.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.71"
					y1="550.09"
					x2="908.04"
					y2="550.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.04"
					y1="550.19"
					x2="908.36"
					y2="550.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.36"
					y1="550.34"
					x2="908.64"
					y2="550.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.64"
					y1="550.56"
					x2="908.88"
					y2="550.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.88"
					y1="550.82"
					x2="909.08"
					y2="551.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.08"
					y1="551.12"
					x2="909.23"
					y2="551.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.23"
					y1="551.45"
					x2="909.32"
					y2="551.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.32"
					y1="551.81"
					x2="909.35"
					y2="552.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.35"
					y1="552.17"
					x2="909.32"
					y2="552.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.32"
					y1="552.54"
					x2="909.23"
					y2="552.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.23"
					y1="552.9"
					x2="909.08"
					y2="553.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.08"
					y1="553.23"
					x2="908.88"
					y2="553.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.88"
					y1="553.53"
					x2="908.64"
					y2="553.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.64"
					y1="553.79"
					x2="908.36"
					y2="554"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.36"
					y1="554"
					x2="908.04"
					y2="554.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.04"
					y1="554.16"
					x2="907.71"
					y2="554.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.71"
					y1="554.25"
					x2="907.37"
					y2="554.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.37"
					y1="554.28"
					x2="907.02"
					y2="554.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.02"
					y1="554.25"
					x2="906.69"
					y2="554.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.69"
					y1="554.16"
					x2="906.38"
					y2="554"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.38"
					y1="554"
					x2="906.09"
					y2="553.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.09"
					y1="553.79"
					x2="905.85"
					y2="553.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.85"
					y1="553.53"
					x2="905.65"
					y2="553.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.65"
					y1="553.23"
					x2="905.5"
					y2="552.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.5"
					y1="552.9"
					x2="905.41"
					y2="552.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.41"
					y1="552.54"
					x2="905.38"
					y2="552.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="916.58 553.99 913.71 553.7 913.48 553.66 913.26 553.58 913.06 553.46 909.44 552.98 909.31 552.95 909.19 552.9 909.08 552.83 908.99 552.74 908.9 552.63 908.84 552.51 908.79 552.38 908.77 552.24 908.77 552.1 908.79 551.97 908.84 551.84 908.9 551.72 908.99 551.61 909.08 551.51 909.19 551.44 909.31 551.39 909.44 551.36 913.06 550.88 913.26 550.77 913.48 550.69 913.71 550.64 916.58 550.35 916.88 550.38 917.16 550.46 917.43 550.6 917.68 550.78 917.89 551 918.06 551.26 918.18 551.55 918.26 551.86 918.29 552.17 918.26 552.49 918.18 552.79 918.06 553.08 917.89 553.34 917.68 553.57 917.43 553.75 917.16 553.88 916.88 553.97 916.58 553.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="916.58"
					y1="553.99"
					x2="913.71"
					y2="553.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.06"
					y1="553.46"
					x2="909.44"
					y2="552.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.44"
					y1="551.36"
					x2="913.06"
					y2="550.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.71"
					y1="550.64"
					x2="916.58"
					y2="550.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.88"
					y1="551.18"
					x2="913.86"
					y2="551.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.86"
					y1="553.16"
					x2="914.88"
					y2="553.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.88"
					y1="553.16"
					x2="914.88"
					y2="551.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m913.71,553.7c-.23-.03-.45-.1-.65-.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m909.44,552.98c-.38-.05-.67-.4-.67-.81s.29-.76.67-.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m913.06,550.88c.19-.13.42-.22.65-.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m916.58,550.35c.94,0,1.71.81,1.71,1.82s-.77,1.82-1.71,1.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m913.86,553.16c-.51,0-.93-.44-.93-.99s.42-.99.93-.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m913.06,553.46c-.41-.28-.66-.77-.66-1.29s.25-1.01.66-1.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="383.2 925.41 383.2 871.43 488.66 871.43 488.66 925.41 383.2 925.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="383.2"
					y1="925.41"
					x2="383.2"
					y2="871.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.2"
					y1="871.43"
					x2="488.66"
					y2="871.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.66"
					y1="871.43"
					x2="488.66"
					y2="925.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.66"
					y1="925.41"
					x2="383.2"
					y2="925.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.19"
					y1="921.93"
					x2="386.68"
					y2="921.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.68"
					y1="921.93"
					x2="386.68"
					y2="874.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.68"
					y1="874.91"
					x2="485.19"
					y2="874.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.19"
					y1="874.91"
					x2="485.19"
					y2="921.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.19"
					y1="921.93"
					x2="441.03"
					y2="900.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.19"
					y1="874.91"
					x2="441.03"
					y2="896.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.68"
					y1="921.93"
					x2="430.83"
					y2="900.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.68"
					y1="874.91"
					x2="430.83"
					y2="896.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.93"
					y1="901.9"
					x2="435.93"
					y2="894.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.46"
					y1="898.42"
					x2="439.41"
					y2="898.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m441.5,898.42c0-3.08-2.49-5.57-5.57-5.57s-5.56,2.49-5.56,5.57,2.49,5.56,5.56,5.56,5.57-2.49,5.57-5.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m439.41,898.42c0-1.92-1.56-3.48-3.48-3.48s-3.48,1.56-3.48,3.48,1.56,3.48,3.48,3.48,3.48-1.56,3.48-3.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="488.66 898.42 481.28 903.85 481.28 892.99 488.66 898.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="488.66"
					y1="898.42"
					x2="481.28"
					y2="903.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.28"
					y1="903.85"
					x2="481.28"
					y2="892.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.28"
					y1="892.99"
					x2="488.66"
					y2="898.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.59"
					y1="898.42"
					x2="475.06"
					y2="898.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.28"
					y1="898.42"
					x2="481.28"
					y2="892.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.28"
					y1="892.99"
					x2="488.66"
					y2="898.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.28"
					y1="898.42"
					x2="481.28"
					y2="903.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.28"
					y1="903.85"
					x2="488.66"
					y2="898.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.74"
					y1="896.82"
					x2="475.81"
					y2="894.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.74"
					y1="900.02"
					x2="475.81"
					y2="902.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="900.52 624.58 935.86 624.58 935.86 579.38 900.52 579.38 900.52 624.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="900.52"
					y1="624.58"
					x2="900.52"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.86"
					y1="624.58"
					x2="935.86"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.52"
					y1="579.38"
					x2="935.86"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.52"
					y1="624.58"
					x2="935.86"
					y2="624.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.47"
					y1="624.58"
					x2="934.47"
					y2="579.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.91"
					y1="619.66"
					x2="908.91"
					y2="584.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.91"
					y1="584.31"
					x2="930.12"
					y2="584.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.12"
					y1="584.31"
					x2="930.12"
					y2="619.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.12"
					y1="619.66"
					x2="908.91"
					y2="619.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.52"
					y1="621.05"
					x2="907.52"
					y2="582.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.52"
					y1="582.92"
					x2="931.51"
					y2="582.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.51"
					y1="582.92"
					x2="931.51"
					y2="621.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.51"
					y1="621.05"
					x2="907.52"
					y2="621.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m927.42,601.98c0-1.15-.94-2.09-2.09-2.09s-2.09.94-2.09,2.09.94,2.09,2.09,2.09,2.09-.94,2.09-2.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="933.95 603.72 931.03 603.44 930.37 603.22 926.68 602.75 926.2 602.5 926 601.98 926.2 601.47 926.68 601.21 930.37 600.75 931.03 600.52 933.95 600.24 935.18 600.75 935.69 601.98 935.18 603.21 933.95 603.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="933.95"
					y1="603.72"
					x2="931.03"
					y2="603.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m931.03,603.44c-.23-.02-.46-.1-.66-.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.37"
					y1="603.22"
					x2="926.68"
					y2="602.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m926.68,602.75c-.39-.05-.68-.38-.68-.77s.29-.72.68-.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.68"
					y1="601.21"
					x2="930.37"
					y2="600.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m930.37,600.75c.2-.13.43-.21.66-.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.03"
					y1="600.52"
					x2="933.95"
					y2="600.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m933.95,600.24c.96,0,1.74.78,1.74,1.74s-.78,1.74-1.74,1.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.21"
					y1="601.04"
					x2="931.18"
					y2="601.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.18"
					y1="602.93"
					x2="932.21"
					y2="602.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.21"
					y1="602.93"
					x2="932.21"
					y2="601.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m931.18,602.93c-.52,0-.95-.42-.95-.94s.43-.95.95-.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m930.37,603.22c-.42-.27-.67-.74-.67-1.23s.25-.97.67-1.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="889.44 647.88 888.04 651.03 887.55 654.45 888.04 657.87 889.44 661.03 893.47 664.68 898.73 666.68 905.31 667.38 911.77 665.9 917.57 666.38 922.86 668.8 924.35 669.75 927.42 670.87 930.69 670.7 931.98 670.2 935.41 670.2 935.41 668.77 933.85 668.77 935.3 666.37 935.86 663.63 935.86 645.27 934.9 641.72 932.37 639.06 928.88 637.92 928.46 637.92 926.25 638.28 922.78 640.14 917.55 642.54 911.81 643.02 905.34 641.53 898.73 642.22 893.47 644.23 889.44 647.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="919.54"
					y1="660.99"
					x2="919.54"
					y2="647.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.86"
					y1="645.27"
					x2="935.86"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.19"
					y1="645.27"
					x2="935.19"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.86"
					y1="663.63"
					x2="935.86"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.19"
					y1="663.63"
					x2="935.19"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.54"
					y1="648.25"
					x2="921.98"
					y2="648.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.98"
					y1="648.25"
					x2="921.98"
					y2="650.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.98"
					y1="650.27"
					x2="919.54"
					y2="650.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.54"
					y1="660.65"
					x2="921.98"
					y2="660.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.98"
					y1="660.65"
					x2="921.98"
					y2="658.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.98"
					y1="658.63"
					x2="919.54"
					y2="658.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.33"
					y1="668.77"
					x2="935.41"
					y2="668.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.33"
					y1="670.2"
					x2="935.41"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.41"
					y1="670.2"
					x2="935.41"
					y2="668.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.33"
					y1="670.2"
					x2="929.33"
					y2="668.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.55"
					y1="654.45"
					x2="887.8"
					y2="652.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.8"
					y1="652.26"
					x2="888.36"
					y2="650.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.36"
					y1="650.14"
					x2="889.44"
					y2="647.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.44"
					y1="647.88"
					x2="891.23"
					y2="645.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.23"
					y1="645.8"
					x2="893.47"
					y2="644.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.47"
					y1="644.23"
					x2="896.02"
					y2="643.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.02"
					y1="643.07"
					x2="898.73"
					y2="642.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.73"
					y1="642.22"
					x2="903.11"
					y2="641.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.11"
					y1="641.46"
					x2="907.51"
					y2="641.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.51"
					y1="641.67"
					x2="910.93"
					y2="642.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.93"
					y1="642.66"
					x2="914.23"
					y2="644.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.23"
					y1="644.21"
					x2="917.18"
					y2="646.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.18"
					y1="646.05"
					x2="919.54"
					y2="647.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.81"
					y1="643.02"
					x2="914.87"
					y2="643"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.87"
					y1="643"
					x2="917.86"
					y2="642.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.86"
					y1="642.5"
					x2="921.05"
					y2="641.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.05"
					y1="641.23"
					x2="925.76"
					y2="638.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.76"
					y1="638.45"
					x2="928.1"
					y2="637.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.1"
					y1="637.93"
					x2="930.43"
					y2="638.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.43"
					y1="638.13"
					x2="932.55"
					y2="639.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.55"
					y1="639.04"
					x2="934.26"
					y2="640.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.26"
					y1="640.64"
					x2="935.13"
					y2="642.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.13"
					y1="642.21"
					x2="935.61"
					y2="643.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.61"
					y1="643.71"
					x2="935.86"
					y2="645.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.19"
					y1="645.27"
					x2="934.68"
					y2="643.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="643.13"
					x2="933.61"
					y2="641.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.61"
					y1="641.85"
					x2="932.11"
					y2="641.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.11"
					y1="641.05"
					x2="930.14"
					y2="640.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.14"
					y1="640.67"
					x2="928.11"
					y2="640.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.11"
					y1="640.59"
					x2="927.1"
					y2="640.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.1"
					y1="640.6"
					x2="926.3"
					y2="641.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.3"
					y1="641.03"
					x2="926.06"
					y2="641.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.06"
					y1="641.52"
					x2="924.49"
					y2="647.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.49"
					y1="647.08"
					x2="923.81"
					y2="652.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.81"
					y1="652.63"
					x2="923.81"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.77"
					y1="665.9"
					x2="914.84"
					y2="665.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.84"
					y1="665.92"
					x2="917.84"
					y2="666.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.84"
					y1="666.43"
					x2="921.05"
					y2="667.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.05"
					y1="667.67"
					x2="925.76"
					y2="670.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.76"
					y1="670.45"
					x2="927.32"
					y2="670.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.32"
					y1="670.88"
					x2="928.93"
					y2="670.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.93"
					y1="670.98"
					x2="930.51"
					y2="670.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.51"
					y1="670.76"
					x2="931.98"
					y2="670.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.19"
					y1="663.63"
					x2="934.68"
					y2="665.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="665.78"
					x2="933.61"
					y2="667.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.61"
					y1="667.05"
					x2="932.11"
					y2="667.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.11"
					y1="667.85"
					x2="930.14"
					y2="668.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.14"
					y1="668.23"
					x2="928.11"
					y2="668.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="928.11"
					y1="668.32"
					x2="927.1"
					y2="668.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.1"
					y1="668.3"
					x2="926.3"
					y2="667.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.3"
					y1="667.88"
					x2="926.06"
					y2="667.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.06"
					y1="667.38"
					x2="924.49"
					y2="661.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.49"
					y1="661.83"
					x2="923.81"
					y2="656.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.81"
					y1="656.28"
					x2="923.81"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.55"
					y1="654.45"
					x2="887.8"
					y2="656.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.8"
					y1="656.64"
					x2="888.36"
					y2="658.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.36"
					y1="658.77"
					x2="889.44"
					y2="661.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.44"
					y1="661.03"
					x2="891.23"
					y2="663.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.23"
					y1="663.1"
					x2="893.47"
					y2="664.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.47"
					y1="664.68"
					x2="896.02"
					y2="665.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.02"
					y1="665.84"
					x2="898.73"
					y2="666.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.73"
					y1="666.68"
					x2="903.11"
					y2="667.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.11"
					y1="667.44"
					x2="907.51"
					y2="667.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.51"
					y1="667.24"
					x2="910.93"
					y2="666.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.93"
					y1="666.24"
					x2="914.23"
					y2="664.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.23"
					y1="664.7"
					x2="917.18"
					y2="662.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.18"
					y1="662.86"
					x2="919.54"
					y2="660.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.49"
					y1="639.07"
					x2="923.99"
					y2="639.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.99"
					y1="639.42"
					x2="923.24"
					y2="640.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.24"
					y1="640.43"
					x2="923.07"
					y2="641.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.07"
					y1="641.31"
					x2="922.37"
					y2="652.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.37"
					y1="652.6"
					x2="922.37"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.49"
					y1="669.84"
					x2="923.99"
					y2="669.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.99"
					y1="669.48"
					x2="923.24"
					y2="668.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.24"
					y1="668.47"
					x2="923.07"
					y2="667.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.07"
					y1="667.6"
					x2="922.37"
					y2="656.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.37"
					y1="656.3"
					x2="922.37"
					y2="654.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.85"
					y1="668.77"
					x2="934.26"
					y2="668.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.26"
					y1="668.26"
					x2="935.13"
					y2="666.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.13"
					y1="666.7"
					x2="935.6"
					y2="665.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.6"
					y1="665.2"
					x2="935.86"
					y2="663.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="935.86 633.24 935.15 633.24 935.15 636.78 935.86 636.78 935.86 633.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="935.86"
					y1="636.78"
					x2="935.86"
					y2="633.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.15"
					y1="636.78"
					x2="935.86"
					y2="636.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.15"
					y1="633.24"
					x2="935.15"
					y2="636.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.86"
					y1="633.24"
					x2="935.15"
					y2="633.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="935.86 675.66 935.86 672.12 935.15 672.12 935.15 675.66 935.86 675.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="935.15"
					y1="675.66"
					x2="935.86"
					y2="675.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.15"
					y1="672.12"
					x2="935.15"
					y2="675.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.86"
					y1="672.12"
					x2="935.15"
					y2="672.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.86"
					y1="675.66"
					x2="935.86"
					y2="672.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="935.15 634.66 929.4 634.66 929.4 635.36 935.15 635.36 935.15 634.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="935.15"
					y1="635.36"
					x2="935.15"
					y2="634.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.4"
					y1="635.36"
					x2="935.15"
					y2="635.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.4"
					y1="634.66"
					x2="929.4"
					y2="635.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.15"
					y1="634.66"
					x2="929.4"
					y2="634.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="935.15 674.25 935.15 673.54 929.4 673.54 929.4 674.25 935.15 674.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="929.4"
					y1="674.25"
					x2="935.15"
					y2="674.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.4"
					y1="673.54"
					x2="929.4"
					y2="674.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.15"
					y1="673.54"
					x2="929.4"
					y2="673.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.15"
					y1="674.25"
					x2="935.15"
					y2="673.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="931.17 635.36 929.75 635.36 929.75 673.54 931.17 673.54 931.17 635.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="931.17"
					y1="673.54"
					x2="931.17"
					y2="635.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.75"
					y1="673.54"
					x2="931.17"
					y2="673.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.75"
					y1="635.36"
					x2="929.75"
					y2="673.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.17"
					y1="635.36"
					x2="929.75"
					y2="635.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="466.72 824.08 466.72 869.28 502.05 869.28 502.05 824.08 466.72 824.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="466.72"
					y1="824.08"
					x2="466.72"
					y2="869.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.05"
					y1="824.08"
					x2="502.05"
					y2="869.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.72"
					y1="869.28"
					x2="502.05"
					y2="869.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.72"
					y1="824.08"
					x2="502.05"
					y2="824.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.66"
					y1="824.08"
					x2="500.66"
					y2="869.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.11"
					y1="829.01"
					x2="475.11"
					y2="864.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.11"
					y1="864.36"
					x2="496.32"
					y2="864.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.32"
					y1="864.36"
					x2="496.32"
					y2="829.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.32"
					y1="829.01"
					x2="475.11"
					y2="829.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.72"
					y1="827.62"
					x2="473.72"
					y2="865.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.72"
					y1="865.75"
					x2="497.71"
					y2="865.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.71"
					y1="865.75"
					x2="497.71"
					y2="827.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.71"
					y1="827.62"
					x2="473.72"
					y2="827.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m493.62,846.68c0-1.15-.93-2.09-2.09-2.09s-2.09.94-2.09,2.09.94,2.09,2.09,2.09,2.09-.94,2.09-2.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="500.14 844.94 497.22 845.22 496.56 845.45 492.88 845.91 492.39 846.17 492.2 846.68 492.39 847.2 492.88 847.46 496.56 847.92 497.22 848.14 500.14 848.42 501.37 847.91 501.88 846.68 501.37 845.45 500.14 844.94"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m500.14,844.94c.96,0,1.74.78,1.74,1.74s-.78,1.74-1.74,1.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.22"
					y1="848.14"
					x2="500.14"
					y2="848.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m497.22,848.14c-.23-.02-.46-.1-.66-.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.88"
					y1="847.46"
					x2="496.56"
					y2="847.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m492.88,847.46c-.39-.05-.68-.38-.68-.77s.3-.72.68-.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.56"
					y1="845.45"
					x2="492.88"
					y2="845.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m496.56,845.45c.2-.13.43-.21.66-.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.14"
					y1="844.94"
					x2="497.22"
					y2="845.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.41"
					y1="847.63"
					x2="497.37"
					y2="847.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.37"
					y1="845.74"
					x2="498.41"
					y2="845.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.41"
					y1="845.74"
					x2="498.41"
					y2="847.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m497.37,847.63c-.52,0-.94-.42-.94-.94s.42-.95.94-.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m496.56,847.92c-.42-.27-.67-.74-.67-1.23s.25-.97.67-1.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="455.64 800.79 459.67 804.44 464.93 806.44 471.53 807.13 478.01 805.64 483.74 806.12 488.97 808.52 492.45 810.39 494.65 810.75 495.08 810.75 498.57 809.61 501.1 806.94 502.05 803.39 502.05 785.03 501.49 782.29 500.04 779.89 501.61 779.89 501.61 778.46 498.17 778.46 496.88 777.96 493.62 777.79 490.55 778.91 489.06 779.86 483.76 782.28 477.96 782.76 471.51 781.29 464.93 781.98 459.67 783.99 455.64 787.64 454.23 790.79 453.74 794.21 454.23 797.63 455.64 800.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="485.73"
					y1="787.67"
					x2="485.73"
					y2="800.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.05"
					y1="803.39"
					x2="502.05"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.39"
					y1="803.39"
					x2="501.39"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.05"
					y1="785.03"
					x2="502.05"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.39"
					y1="785.03"
					x2="501.39"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.73"
					y1="800.41"
					x2="488.18"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.18"
					y1="800.41"
					x2="488.18"
					y2="798.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.18"
					y1="798.39"
					x2="485.73"
					y2="798.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.73"
					y1="788.01"
					x2="488.18"
					y2="788.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.18"
					y1="788.01"
					x2="488.18"
					y2="790.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.18"
					y1="790.03"
					x2="485.73"
					y2="790.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.53"
					y1="779.89"
					x2="501.61"
					y2="779.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.53"
					y1="778.46"
					x2="501.61"
					y2="778.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.61"
					y1="778.46"
					x2="501.61"
					y2="779.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.53"
					y1="778.46"
					x2="495.53"
					y2="779.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.74"
					y1="794.21"
					x2="453.99"
					y2="796.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.99"
					y1="796.41"
					x2="454.56"
					y2="798.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.56"
					y1="798.53"
					x2="455.64"
					y2="800.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.64"
					y1="800.79"
					x2="457.42"
					y2="802.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.42"
					y1="802.87"
					x2="459.67"
					y2="804.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.67"
					y1="804.44"
					x2="462.22"
					y2="805.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.22"
					y1="805.6"
					x2="464.93"
					y2="806.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.93"
					y1="806.44"
					x2="469.3"
					y2="807.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.3"
					y1="807.21"
					x2="473.71"
					y2="807"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.71"
					y1="807"
					x2="477.12"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.12"
					y1="806.01"
					x2="480.42"
					y2="804.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.42"
					y1="804.46"
					x2="483.37"
					y2="802.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.37"
					y1="802.62"
					x2="485.73"
					y2="800.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.01"
					y1="805.64"
					x2="481.07"
					y2="805.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.07"
					y1="805.66"
					x2="484.05"
					y2="806.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.05"
					y1="806.17"
					x2="487.25"
					y2="807.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.25"
					y1="807.43"
					x2="491.96"
					y2="810.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.96"
					y1="810.21"
					x2="494.3"
					y2="810.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.3"
					y1="810.73"
					x2="496.63"
					y2="810.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.63"
					y1="810.54"
					x2="498.75"
					y2="809.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.75"
					y1="809.63"
					x2="500.46"
					y2="808.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.46"
					y1="808.02"
					x2="501.32"
					y2="806.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.32"
					y1="806.46"
					x2="501.8"
					y2="804.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.8"
					y1="804.96"
					x2="502.05"
					y2="803.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.39"
					y1="803.39"
					x2="500.88"
					y2="805.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.88"
					y1="805.53"
					x2="499.8"
					y2="806.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.8"
					y1="806.81"
					x2="498.3"
					y2="807.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.3"
					y1="807.61"
					x2="496.33"
					y2="807.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.33"
					y1="807.99"
					x2="494.3"
					y2="808.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.3"
					y1="808.08"
					x2="493.29"
					y2="808.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.29"
					y1="808.06"
					x2="492.49"
					y2="807.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.49"
					y1="807.64"
					x2="492.26"
					y2="807.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.26"
					y1="807.14"
					x2="490.68"
					y2="801.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.68"
					y1="801.59"
					x2="490.01"
					y2="796.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.01"
					y1="796.04"
					x2="490.01"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.96"
					y1="782.76"
					x2="481.04"
					y2="782.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.04"
					y1="782.74"
					x2="484.03"
					y2="782.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.03"
					y1="782.24"
					x2="487.25"
					y2="780.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.25"
					y1="780.99"
					x2="491.96"
					y2="778.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.96"
					y1="778.22"
					x2="493.52"
					y2="777.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.52"
					y1="777.78"
					x2="495.13"
					y2="777.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.13"
					y1="777.68"
					x2="496.7"
					y2="777.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.7"
					y1="777.91"
					x2="498.17"
					y2="778.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.39"
					y1="785.03"
					x2="500.88"
					y2="782.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.88"
					y1="782.89"
					x2="499.8"
					y2="781.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.8"
					y1="781.61"
					x2="498.3"
					y2="780.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.3"
					y1="780.81"
					x2="496.33"
					y2="780.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.33"
					y1="780.44"
					x2="494.3"
					y2="780.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.3"
					y1="780.35"
					x2="493.29"
					y2="780.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.29"
					y1="780.36"
					x2="492.49"
					y2="780.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.49"
					y1="780.79"
					x2="492.26"
					y2="781.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.26"
					y1="781.28"
					x2="490.68"
					y2="786.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.68"
					y1="786.84"
					x2="490.01"
					y2="792.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.01"
					y1="792.39"
					x2="490.01"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.74"
					y1="794.21"
					x2="453.99"
					y2="792.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.99"
					y1="792.02"
					x2="454.56"
					y2="789.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.56"
					y1="789.9"
					x2="455.64"
					y2="787.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.64"
					y1="787.64"
					x2="457.42"
					y2="785.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.42"
					y1="785.56"
					x2="459.67"
					y2="783.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.67"
					y1="783.99"
					x2="462.22"
					y2="782.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.22"
					y1="782.82"
					x2="464.93"
					y2="781.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.93"
					y1="781.98"
					x2="469.3"
					y2="781.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.3"
					y1="781.22"
					x2="473.71"
					y2="781.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.71"
					y1="781.43"
					x2="477.12"
					y2="782.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.12"
					y1="782.42"
					x2="480.42"
					y2="783.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.42"
					y1="783.97"
					x2="483.37"
					y2="785.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.37"
					y1="785.8"
					x2="485.73"
					y2="787.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.69"
					y1="809.6"
					x2="490.19"
					y2="809.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.19"
					y1="809.25"
					x2="489.44"
					y2="808.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.44"
					y1="808.23"
					x2="489.27"
					y2="807.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.27"
					y1="807.36"
					x2="488.56"
					y2="796.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.56"
					y1="796.06"
					x2="488.56"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.69"
					y1="778.83"
					x2="490.19"
					y2="779.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.19"
					y1="779.18"
					x2="489.44"
					y2="780.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.44"
					y1="780.19"
					x2="489.27"
					y2="781.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.27"
					y1="781.07"
					x2="488.56"
					y2="792.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.56"
					y1="792.36"
					x2="488.56"
					y2="794.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.04"
					y1="779.89"
					x2="500.46"
					y2="780.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.46"
					y1="780.4"
					x2="501.32"
					y2="781.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.32"
					y1="781.97"
					x2="501.8"
					y2="783.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.8"
					y1="783.47"
					x2="502.05"
					y2="785.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="502.05 815.42 501.35 815.42 501.35 811.89 502.05 811.89 502.05 815.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="502.05"
					y1="815.42"
					x2="501.35"
					y2="815.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.35"
					y1="815.42"
					x2="501.35"
					y2="811.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.35"
					y1="811.89"
					x2="502.05"
					y2="811.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.05"
					y1="811.89"
					x2="502.05"
					y2="815.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="502.05 773 502.05 776.54 501.35 776.54 501.35 773 502.05 773"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="502.05"
					y1="773"
					x2="502.05"
					y2="776.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.05"
					y1="776.54"
					x2="501.35"
					y2="776.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.35"
					y1="776.54"
					x2="501.35"
					y2="773"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.35"
					y1="773"
					x2="502.05"
					y2="773"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="501.35 814.01 495.59 814.01 495.59 813.3 501.35 813.3 501.35 814.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="501.35"
					y1="814.01"
					x2="495.59"
					y2="814.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.59"
					y1="814.01"
					x2="495.59"
					y2="813.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.59"
					y1="813.3"
					x2="501.35"
					y2="813.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.35"
					y1="813.3"
					x2="501.35"
					y2="814.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="501.35 774.42 501.35 775.12 495.59 775.12 495.59 774.42 501.35 774.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="501.35"
					y1="774.42"
					x2="501.35"
					y2="775.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.35"
					y1="775.12"
					x2="495.59"
					y2="775.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.59"
					y1="775.12"
					x2="495.59"
					y2="774.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.59"
					y1="774.42"
					x2="501.35"
					y2="774.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="497.36 813.3 495.95 813.3 495.95 775.12 497.36 775.12 497.36 813.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="497.36"
					y1="813.3"
					x2="495.95"
					y2="813.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.95"
					y1="813.3"
					x2="495.95"
					y2="775.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.95"
					y1="775.12"
					x2="497.36"
					y2="775.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.36"
					y1="775.12"
					x2="497.36"
					y2="813.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.24"
					y1="717.31"
					x2="483.24"
					y2="704.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.24"
					y1="704.94"
					x2="449.66"
					y2="704.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="717.31"
					x2="442.59"
					y2="717.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.59"
					y1="749.13"
					x2="490.31"
					y2="749.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="749.13"
					x2="490.31"
					y2="701.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.59"
					y1="701.41"
					x2="442.59"
					y2="749.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="702.29"
					x2="442.59"
					y2="702.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.66"
					y1="717.31"
					x2="449.66"
					y2="704.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.31"
					y1="701.41"
					x2="442.59"
					y2="701.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.66"
					y1="741.82"
					x2="599.15"
					y2="741.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.15"
					y1="741.82"
					x2="599.15"
					y2="740.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.15"
					y1="740.05"
					x2="595.66"
					y2="740.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="688.68"
					x2="587.73"
					y2="691.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="693.65"
					x2="587.73"
					y2="697.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="700.44"
					x2="587.73"
					y2="704.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="707.22"
					x2="587.73"
					y2="711.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="714.01"
					x2="587.73"
					y2="718.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="720.8"
					x2="587.73"
					y2="725.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="727.58"
					x2="587.73"
					y2="731.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="734.37"
					x2="587.73"
					y2="738.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.73"
					y1="741.16"
					x2="587.73"
					y2="743.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.9"
					y1="690.7"
					x2="719.32"
					y2="690.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.46"
					y1="652.46"
					x2="248.52"
					y2="652.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.52"
					y1="638.32"
					x2="98.92"
					y2="638.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.14"
					y1="849.69"
					x2="64.14"
					y2="709.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50"
					y1="709.47"
					x2="50"
					y2="849.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="480.53"
					x2="287.65"
					y2="285.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.51"
					y1="283.52"
					x2="273.51"
					y2="482.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.51"
					y1="482.3"
					x2="277.04"
					y2="482.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.96"
					y1="233.68"
					x2="514.19"
					y2="233.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.19"
					y1="247.82"
					x2="373.96"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.28"
					y1="233.68"
					x2="781.51"
					y2="233.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.51"
					y1="247.82"
					x2="641.28"
					y2="247.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.24"
					y1="743.83"
					x2="449.66"
					y2="743.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.66"
					y1="743.83"
					x2="449.66"
					y2="720.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.66"
					y1="720.85"
					x2="483.24"
					y2="720.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.24"
					y1="720.85"
					x2="483.24"
					y2="743.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="690.7"
					x2="698.11"
					y2="694.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="696.91"
					x2="698.11"
					y2="701.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="703.7"
					x2="698.11"
					y2="707.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="710.49"
					x2="698.11"
					y2="714.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="717.27"
					x2="698.11"
					y2="721.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="724.06"
					x2="698.11"
					y2="728.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="730.85"
					x2="698.11"
					y2="735.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="737.64"
					x2="698.11"
					y2="741.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="744.42"
					x2="698.11"
					y2="748.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="751.21"
					x2="698.11"
					y2="755.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="758"
					x2="698.11"
					y2="762.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="764.78"
					x2="698.11"
					y2="769.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="771.57"
					x2="698.11"
					y2="775.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="778.36"
					x2="698.11"
					y2="782.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="785.14"
					x2="698.11"
					y2="789.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="791.93"
					x2="698.11"
					y2="796.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="798.72"
					x2="698.11"
					y2="802.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="805.5"
					x2="698.11"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.52"
					y1="809.17"
					x2="569.96"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.5"
					y1="809.17"
					x2="576.74"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.29"
					y1="809.17"
					x2="583.53"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.08"
					y1="809.17"
					x2="590.32"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.86"
					y1="809.17"
					x2="597.11"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.65"
					y1="809.17"
					x2="603.89"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.44"
					y1="809.17"
					x2="610.68"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.22"
					y1="809.17"
					x2="617.47"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.01"
					y1="809.17"
					x2="624.25"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="626.8"
					y1="809.17"
					x2="631.04"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.58"
					y1="809.17"
					x2="637.83"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.37"
					y1="809.17"
					x2="644.61"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.16"
					y1="809.17"
					x2="651.4"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.95"
					y1="809.17"
					x2="658.19"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.73"
					y1="809.17"
					x2="664.97"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.52"
					y1="809.17"
					x2="671.76"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.31"
					y1="809.17"
					x2="678.55"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.09"
					y1="809.17"
					x2="685.33"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.88"
					y1="809.17"
					x2="692.12"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.67"
					y1="809.17"
					x2="698.11"
					y2="809.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="736.75 690.71 736.75 704.84 733.45 704.84 733.45 844.52 516.2 844.52 516.2 939.55 50 939.55 50 849.69 64.14 849.69 64.14 882.73 121.86 882.73 121.86 925.42 374.37 925.42 374.37 828.88 383.2 828.88 383.2 925.42 488.66 925.42 488.66 869.28 502.05 869.28 502.05 759.96 383.2 759.96 383.2 772.33 374.37 772.33 374.37 747.29 383.2 747.29 383.2 751.12 427.93 751.12 427.93 697.52 383.2 697.52 383.2 701.35 374.37 701.35 374.37 697.52 368.27 697.52 368.27 688.68 441.71 688.68 441.71 697.52 436.78 697.52 436.78 751.12 496.13 751.12 496.13 697.52 491.2 697.52 491.2 688.68 533.6 688.68 533.6 743.59 545.31 743.59 545.31 830.38 719.32 830.38 719.32 690.71 736.75 690.71"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="950 510.83 950 704.84 803.9 704.84 803.9 690.71 808.16 690.71 808.16 686.78 817 686.78 817 690.71 935.86 690.71 935.86 579.38 920.76 579.38 920.76 524.96 817 524.96 817 630.23 808.16 630.23 808.16 588.65 763.06 588.65 763.06 579.81 808.16 579.81 808.16 524.96 650.96 524.96 650.96 579.81 691.47 579.81 691.47 588.65 577.77 588.65 577.77 507.1 586.6 507.1 586.6 516.12 671.16 516.12 671.16 466.33 695.6 466.33 695.6 475.18 680 475.18 680 516.12 773.15 516.12 773.15 475.18 752.15 475.18 752.15 466.33 822.67 466.33 822.67 259.95 787.53 259.95 787.53 247.82 781.51 247.82 781.51 233.68 836.81 233.68 836.81 510.83 950 510.83"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="98.92 638.31 98.92 652.46 96.06 652.46 96.06 691.91 64.14 691.91 64.14 709.47 50 709.47 50 638.31 98.92 638.31"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="311.71 688.68 311.71 697.52 278.82 697.52 278.82 652.46 248.53 652.46 248.53 638.31 273.5 638.31 273.5 549.65 287.64 549.65 287.64 688.68 311.71 688.68"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="373.97 233.68 373.97 247.82 330.09 247.82 330.09 263.56 287.64 263.56 287.64 283.51 273.5 283.51 273.5 233.68 373.97 233.68"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
				<polygon
					points="641.28 233.68 641.28 314.58 586.6 314.58 586.6 450.55 577.77 450.55 577.77 247.82 514.18 247.82 514.18 233.68 641.28 233.68"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.26"
				/>
			</g>
			<g id="text">
				<path d="m562.05,721.05h-1.15l-1.38-2.32c-.13-.21-.25-.4-.37-.55-.12-.15-.24-.28-.37-.37-.12-.1-.26-.16-.4-.21-.14-.05-.3-.07-.48-.07h-.79v3.51h-.97v-8.26h2.46c.36,0,.69.05,1,.14.31.09.57.22.79.41.23.18.4.41.53.69.13.27.19.59.19.96,0,.29-.04.55-.13.79-.08.24-.21.45-.37.64-.16.19-.35.35-.58.48-.22.13-.47.23-.75.31v.02c.14.06.26.13.36.21.1.08.2.17.29.28.09.11.18.23.27.37.09.13.19.29.31.47l1.55,2.48Zm-4.95-7.38v2.99h1.31c.24,0,.46-.04.67-.11.21-.07.39-.18.54-.31.15-.14.27-.31.35-.5.08-.2.13-.42.13-.67,0-.44-.14-.79-.43-1.03-.28-.25-.7-.37-1.24-.37h-1.32Zm10.59,4.67h-4.16c.02.66.19,1.16.53,1.52.34.36.8.54,1.39.54.66,0,1.27-.22,1.83-.66v.89c-.52.38-1.2.56-2.06.56s-1.49-.27-1.96-.8c-.48-.54-.71-1.29-.71-2.26,0-.92.26-1.66.78-2.24.52-.58,1.17-.87,1.94-.87s1.37.25,1.79.75c.42.5.63,1.19.63,2.08v.5Zm-.97-.8c0-.55-.14-.97-.4-1.27-.26-.3-.62-.45-1.08-.45s-.82.16-1.13.48c-.31.32-.5.74-.58,1.25h3.18Zm5.2-4.39c-.18-.1-.39-.16-.63-.16-.66,0-.99.42-.99,1.25v.91h1.38v.81h-1.38v5.09h-.94v-5.09h-1.01v-.81h1.01v-.96c0-.62.18-1.11.54-1.46.36-.36.8-.54,1.34-.54.29,0,.52.03.69.1v.85Z" />
				<path d="m572.91,721.17c-.18,0-.33-.06-.46-.19-.12-.13-.18-.28-.18-.46s.06-.33.18-.45c.13-.13.28-.2.46-.2s.33.07.46.2c.13.13.19.28.19.45s-.06.33-.19.46c-.13.13-.28.19-.46.19Z" />
				<path d="m698.98,716.38v-8.19h2.82c.64,0,1.12.04,1.46.12.47.11.87.3,1.2.59.43.37.75.83.97,1.4.22.57.32,1.21.32,1.94,0,.62-.07,1.17-.22,1.65-.15.48-.33.88-.56,1.2-.23.31-.48.56-.75.74-.27.18-.59.31-.98.41-.38.09-.82.14-1.31.14h-2.96Zm1.08-.97h1.75c.54,0,.96-.05,1.27-.15.31-.1.56-.24.74-.42.26-.26.46-.6.6-1.03.15-.44.22-.96.22-1.58,0-.86-.14-1.51-.42-1.97-.28-.46-.62-.77-1.02-.93-.29-.11-.76-.17-1.4-.17h-1.72v6.26Zm8.62.97l-2.17-8.19h1.11l1.25,5.37c.13.56.25,1.12.35,1.68.21-.88.33-1.38.37-1.51l1.56-5.53h1.31l1.17,4.15c.29,1.03.51,2,.64,2.9.1-.52.24-1.11.41-1.78l1.29-5.26h1.09l-2.25,8.19h-1.05l-1.73-6.24c-.15-.52-.23-.84-.26-.96-.09.38-.17.7-.24.96l-1.74,6.24h-1.11Z" />
				<path d="m360.95,467h-6.65v-12.81h1.5v11.45h5.14v1.36Zm2.52-11.47c-.26,0-.49-.09-.67-.27-.18-.18-.28-.4-.28-.68s.09-.5.28-.68c.18-.18.41-.28.67-.28s.49.09.68.28c.19.18.29.4.29.68s-.1.49-.29.67c-.18.18-.41.28-.68.28Zm.71,11.47h-1.46v-9.15h1.46v9.15Zm10.15-9.15l-3.64,9.15h-1.44l-3.47-9.15h1.61l2.32,6.65c.17.49.28.91.32,1.28h.04c.06-.46.15-.87.29-1.24l2.43-6.68h1.55Zm2.32-2.32c-.26,0-.49-.09-.67-.27-.18-.18-.28-.4-.28-.68s.09-.5.28-.68c.18-.18.41-.28.67-.28s.49.09.68.28c.19.18.29.4.29.68s-.1.49-.29.67c-.18.18-.41.28-.68.28Zm.71,11.47h-1.46v-9.15h1.46v9.15Zm10.55,0h-1.46v-5.22c0-1.94-.71-2.91-2.13-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.22h-1.46v-9.15h1.46v1.52h.04c.69-1.16,1.69-1.73,3-1.73,1,0,1.77.32,2.3.97.53.64.79,1.57.79,2.8v5.59Zm10.56-.73c0,3.36-1.61,5.04-4.82,5.04-1.13,0-2.12-.21-2.97-.64v-1.46c1.03.57,2.01.86,2.95.86,2.25,0,3.38-1.2,3.38-3.59v-1h-.04c-.7,1.17-1.74,1.75-3.14,1.75-1.14,0-2.05-.4-2.75-1.21-.69-.82-1.04-1.91-1.04-3.28,0-1.55.37-2.79,1.12-3.71.75-.92,1.77-1.38,3.07-1.38s2.15.49,2.74,1.48h.04v-1.27h1.46v8.41Zm-1.46-3.4v-1.35c0-.73-.25-1.35-.74-1.87-.49-.52-1.1-.78-1.83-.78-.91,0-1.61.33-2.13.99-.51.65-.77,1.57-.77,2.76,0,1.02.24,1.83.73,2.45.49.61,1.15.91,1.96.91s1.49-.29,2-.88c.52-.58.78-1.33.78-2.24Z" />
				<polygon points="407.22 454.19 401.07 469.13 399.7 469.13 405.83 454.19 407.22 454.19" />
				<path d="m408.71,467v-12.81h3.54c4.51,0,6.77,2.08,6.77,6.24,0,1.98-.63,3.57-1.88,4.77-1.25,1.2-2.93,1.8-5.03,1.8h-3.39Zm1.5-11.45v10.09h1.91c1.68,0,2.99-.45,3.92-1.35.93-.9,1.4-2.17,1.4-3.82,0-3.28-1.74-4.92-5.23-4.92h-2Zm11.82-.02c-.26,0-.49-.09-.67-.27-.18-.18-.28-.4-.28-.68s.09-.5.28-.68c.18-.18.41-.28.67-.28s.49.09.68.28c.19.18.29.4.29.68s-.1.49-.29.67c-.18.18-.41.28-.68.28Zm.71,11.47h-1.46v-9.15h1.46v9.15Zm10.5,0h-1.46v-5.22c0-1.94-.71-2.91-2.13-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.22h-1.46v-9.15h1.46v1.52h.04c.69-1.16,1.69-1.73,3-1.73,1,0,1.77.32,2.3.97.53.64.79,1.57.79,2.8v5.59Zm3.46-11.47c-.26,0-.49-.09-.67-.27-.18-.18-.28-.4-.28-.68s.09-.5.28-.68c.18-.18.41-.28.67-.28s.49.09.68.28c.19.18.29.4.29.68s-.1.49-.29.67c-.18.18-.41.28-.68.28Zm.71,11.47h-1.46v-9.15h1.46v9.15Zm10.5,0h-1.46v-5.22c0-1.94-.71-2.91-2.13-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.22h-1.46v-9.15h1.46v1.52h.04c.69-1.16,1.69-1.73,3-1.73,1,0,1.77.32,2.3.97.53.64.79,1.57.79,2.8v5.59Zm10.52-.73c0,3.36-1.61,5.04-4.82,5.04-1.13,0-2.12-.21-2.97-.64v-1.46c1.03.57,2.01.86,2.95.86,2.25,0,3.38-1.2,3.38-3.59v-1h-.04c-.7,1.17-1.74,1.75-3.14,1.75-1.14,0-2.05-.4-2.75-1.21-.69-.82-1.04-1.91-1.04-3.28,0-1.55.37-2.79,1.12-3.71.75-.92,1.77-1.38,3.07-1.38s2.15.49,2.74,1.48h.04v-1.27h1.46v8.41Zm-1.46-3.4v-1.35c0-.73-.25-1.35-.74-1.87-.49-.52-1.1-.78-1.83-.78-.91,0-1.61.33-2.13.99-.51.65-.77,1.57-.77,2.76,0,1.02.24,1.83.73,2.45.49.61,1.15.91,1.96.91s1.49-.29,2-.88c.52-.58.78-1.33.78-2.24Z" />
				<path d="m475.96,467h-1.79l-2.14-3.59c-.2-.33-.39-.62-.57-.85-.18-.24-.38-.43-.57-.58-.19-.15-.4-.26-.63-.32-.22-.07-.47-.11-.75-.11h-1.23v5.45h-1.5v-12.81h3.82c.56,0,1.07.07,1.55.21.48.14.89.35,1.23.63.35.29.63.64.82,1.07.2.42.29.92.29,1.49,0,.45-.07.86-.21,1.23-.13.37-.32.7-.57.99-.24.29-.54.54-.89.75-.35.2-.74.36-1.17.47v.04c.21.1.4.21.55.33.16.12.31.26.46.43.14.17.28.36.42.57.14.21.3.45.47.73l2.4,3.85Zm-7.68-11.45v4.64h2.04c.38,0,.72-.06,1.04-.17.32-.11.6-.27.83-.48.23-.21.41-.47.54-.78.13-.31.2-.65.2-1.04,0-.68-.22-1.22-.67-1.6-.44-.39-1.08-.58-1.92-.58h-2.05Zm13.01,11.67c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm10.56,8.34c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm19.72,8.13h-1.46v-5.25c0-1.01-.16-1.74-.47-2.2-.31-.45-.83-.68-1.57-.68-.63,0-1.16.29-1.6.86-.43.57-.65,1.26-.65,2.05v5.22h-1.46v-5.43c0-1.8-.69-2.7-2.08-2.7-.64,0-1.17.27-1.59.81-.42.54-.63,1.24-.63,2.1v5.22h-1.46v-9.15h1.46v1.45h.04c.65-1.11,1.6-1.66,2.84-1.66.63,0,1.17.18,1.63.53.46.35.78.8.96,1.37.68-1.26,1.69-1.89,3.04-1.89,2.01,0,3.02,1.24,3.02,3.72v5.64Z" />
				<path d="m400.91,485.99h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.06.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Zm8.67-2.64c0,.42-.08.8-.24,1.15-.16.34-.38.64-.67.88-.29.24-.63.43-1.03.57-.4.13-.85.2-1.33.2-.89,0-1.59-.17-2.12-.51v-1.14c.63.49,1.35.74,2.16.74.32,0,.62-.04.88-.12.26-.08.49-.2.68-.36.19-.16.34-.34.44-.57.1-.22.16-.47.16-.75,0-1.22-.87-1.83-2.6-1.83h-.77v-.9h.73c1.53,0,2.3-.57,2.3-1.72,0-1.06-.58-1.59-1.75-1.59-.66,0-1.28.22-1.85.66v-1.03c.59-.36,1.3-.53,2.12-.53.39,0,.74.05,1.06.16s.59.26.81.45c.23.19.4.43.52.7.13.27.19.57.19.9,0,1.23-.62,2.01-1.86,2.37v.03c.32.03.61.11.88.23.27.12.5.27.7.46.19.19.35.42.45.68.11.26.17.54.17.85Z" />
				<rect x="411.63" y="476.68" width=".94" height="2.9" />
				<path d="m414.17,483.4c0-.25.04-.49.12-.74.08-.25.19-.49.33-.7.15-.22.33-.41.54-.59.22-.18.46-.32.73-.42-.4-.23-.72-.51-.96-.86-.24-.36-.36-.75-.36-1.18,0-.34.06-.66.19-.95.13-.29.32-.54.55-.75.23-.21.51-.38.83-.49.32-.12.67-.18,1.04-.18s.73.06,1.05.18c.32.12.6.29.83.5.23.21.42.46.55.75.13.29.19.6.19.94,0,.43-.12.82-.36,1.18-.24.35-.55.64-.95.86.27.1.51.24.72.42.21.18.39.37.53.59.15.22.26.45.34.7.08.25.12.49.12.74,0,.41-.07.78-.22,1.12-.15.34-.36.63-.62.87-.26.24-.58.42-.96.56-.37.13-.78.2-1.22.2s-.85-.07-1.22-.2c-.37-.13-.69-.32-.96-.56-.27-.24-.48-.53-.63-.87-.15-.34-.22-.71-.22-1.12h0Zm1.16-.09c0,.29.04.55.13.79.09.23.22.43.38.6.16.16.36.29.59.38.23.09.49.13.77.13s.52-.05.75-.14c.23-.09.43-.22.59-.38.17-.16.3-.36.39-.6.1-.23.14-.49.14-.78,0-.26-.05-.5-.14-.73-.09-.23-.21-.43-.38-.6s-.36-.31-.59-.41c-.23-.1-.49-.15-.77-.15-.27,0-.52.05-.75.14-.23.09-.42.22-.59.39s-.29.36-.39.6c-.1.23-.14.48-.14.76Zm.33-4.32c0,.22.04.43.12.62.08.19.19.35.33.49.14.14.31.25.49.33.19.08.39.12.6.12s.41-.04.6-.12c.19-.08.36-.19.49-.33.14-.14.25-.31.33-.49.08-.19.12-.39.12-.61s-.04-.43-.12-.62c-.08-.19-.19-.36-.32-.49-.14-.14-.3-.25-.49-.32-.19-.08-.39-.12-.6-.12-.23,0-.44.04-.63.12-.19.08-.35.19-.49.34-.13.14-.24.3-.31.49-.07.19-.11.39-.11.61Z" />
				<path d="m422.78,476.68v2.9h-.94v-2.9h.94Zm2.16,0v2.9h-.94v-2.9h.94Z" />
				<path d="m435.59,479.34l-2.24,3.37,2.2,3.29h-1.24l-1.31-2.16c-.08-.13-.18-.3-.29-.51h-.03s-.12.21-.31.51l-1.33,2.16h-1.23l2.27-3.26-2.17-3.39h1.24l1.29,2.27c.1.17.19.34.28.52h.03l1.66-2.79h1.18Z" />
				<path d="m444.42,479.12c0-.29-.05-.54-.14-.75-.09-.21-.21-.39-.36-.53-.15-.14-.33-.25-.54-.32s-.43-.1-.68-.1c-.21,0-.41.03-.61.08-.2.06-.39.13-.58.23-.19.1-.37.22-.55.36-.17.14-.34.29-.49.46v-1.14c.3-.29.63-.51,1-.66.37-.16.83-.23,1.36-.23.38,0,.73.06,1.06.17.32.11.61.27.84.48.24.21.42.47.56.79.14.31.21.67.21,1.07,0,.37-.04.7-.13,1-.08.3-.21.58-.38.84-.17.26-.38.52-.64.76-.26.24-.57.49-.92.74-.44.31-.8.58-1.09.8-.28.22-.51.43-.68.62-.16.19-.28.38-.35.58-.06.19-.1.41-.1.66h4.64v.96h-5.75v-.46c0-.4.04-.75.13-1.05.09-.3.23-.59.43-.86.2-.27.46-.55.78-.82.32-.27.72-.58,1.19-.92.34-.24.62-.47.84-.7.23-.22.41-.44.55-.66.14-.22.24-.44.29-.67.06-.23.09-.47.09-.73Zm8.8,2.18c0,.78-.07,1.47-.21,2.07-.14.6-.34,1.11-.61,1.53-.26.41-.59.73-.98.94-.39.21-.83.32-1.32.32-.47,0-.89-.1-1.25-.31-.36-.21-.67-.51-.92-.9-.25-.39-.44-.88-.57-1.45-.13-.58-.19-1.23-.19-1.98,0-.81.07-1.53.2-2.16.14-.62.34-1.15.6-1.57.26-.42.59-.74.98-.96.39-.22.84-.32,1.35-.32,1.95,0,2.93,1.59,2.93,4.78Zm-1.09.1c0-2.65-.63-3.98-1.89-3.98-1.33,0-1.99,1.35-1.99,4.05,0,2.52.65,3.78,1.96,3.78s1.93-1.28,1.93-3.85Z" />
				<rect x="454.84" y="476.68" width=".94" height="2.9" />
				<path d="m463.32,480.78c0,.85-.08,1.61-.25,2.28-.17.66-.42,1.23-.74,1.69-.32.46-.72.81-1.19,1.05-.47.24-1,.36-1.6.36s-1.16-.11-1.62-.32v-1.02c.52.29,1.07.44,1.65.44.42,0,.79-.09,1.12-.26.33-.17.62-.42.84-.75.23-.33.41-.74.53-1.23.12-.49.18-1.04.18-1.67h-.03c-.4.8-1.09,1.2-2.08,1.2-.4,0-.76-.07-1.1-.21-.33-.14-.62-.34-.86-.6-.24-.26-.43-.57-.57-.92-.13-.36-.2-.75-.2-1.18,0-.46.07-.88.22-1.26.15-.38.36-.71.62-.98.27-.28.58-.49.95-.64.37-.15.77-.23,1.2-.23.47,0,.88.1,1.24.29.36.19.67.46.92.83.25.36.44.8.57,1.33.13.53.19,1.13.19,1.81Zm-1.15-.96c0-.36-.05-.69-.14-.98-.09-.29-.22-.55-.38-.75-.16-.21-.36-.37-.59-.49-.23-.12-.47-.18-.74-.18s-.49.05-.71.16c-.22.1-.41.24-.58.43-.16.18-.29.4-.38.66-.09.25-.14.53-.14.83,0,.33.04.62.13.88.09.26.22.48.38.66.16.18.36.31.59.41.23.1.49.14.77.14.25,0,.48-.05.7-.14.22-.1.41-.22.57-.38.16-.16.29-.35.38-.56.1-.22.14-.45.14-.7Z" />
				<path d="m465.98,476.68v2.9h-.94v-2.9h.94Zm2.16,0v2.9h-.94v-2.9h.94Z" />
				<path d="m176.35,787.68v-12.81h3.64c1.11,0,1.99.27,2.63.81.65.54.97,1.25.97,2.12,0,.73-.2,1.36-.59,1.89-.39.54-.93.92-1.63,1.14v.04c.86.1,1.55.43,2.07.98.52.55.78,1.26.78,2.14,0,1.1-.39,1.98-1.18,2.66-.79.68-1.78,1.02-2.97,1.02h-3.73Zm1.5-11.45v4.14h1.54c.82,0,1.47-.2,1.94-.59.47-.4.71-.96.71-1.68,0-1.24-.82-1.87-2.46-1.87h-1.72Zm0,5.48v4.61h2.04c.88,0,1.56-.21,2.05-.63.49-.42.73-.99.73-1.72,0-1.51-1.03-2.27-3.09-2.27h-1.72Zm16.12,1.76h-6.46c.02,1.02.3,1.8.82,2.36s1.24.83,2.16.83c1.03,0,1.98-.34,2.84-1.02v1.38c-.8.58-1.87.88-3.19.88s-2.31-.41-3.05-1.24c-.74-.83-1.11-2-1.11-3.51,0-1.42.4-2.58,1.21-3.47.81-.9,1.81-1.35,3.01-1.35s2.12.39,2.78,1.16c.66.77.98,1.85.98,3.22v.77Zm-1.5-1.24c0-.85-.21-1.5-.62-1.97-.4-.47-.96-.71-1.67-.71s-1.28.25-1.76.74c-.48.49-.78,1.14-.89,1.94h4.94Zm11.51,5.45h-1.46v-1.55h-.04c-.68,1.18-1.73,1.77-3.14,1.77-1.15,0-2.07-.41-2.76-1.22-.68-.82-1.03-1.94-1.03-3.35,0-1.51.38-2.72,1.14-3.64.76-.91,1.78-1.37,3.05-1.37s2.17.49,2.74,1.48h.04v-5.66h1.46v13.54Zm-1.46-4.14v-1.35c0-.74-.24-1.36-.73-1.88-.49-.51-1.11-.77-1.86-.77-.89,0-1.6.33-2.11.98-.51.66-.77,1.56-.77,2.72,0,1.05.24,1.89.73,2.5.49.61,1.16.91,1.98.91s1.48-.29,1.98-.88c.51-.59.77-1.33.77-2.23Zm9.19-3.53c-.26-.2-.63-.29-1.11-.29-.63,0-1.15.29-1.57.88-.42.59-.63,1.39-.63,2.41v4.66h-1.46v-9.15h1.46v1.88h.04c.21-.64.53-1.14.96-1.5.43-.36.91-.54,1.44-.54.38,0,.67.04.88.13v1.52Zm5.41,7.88c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6s1.97-1.3,3.4-1.3,2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm10.6,8.34c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm19.76,8.13h-1.46v-5.25c0-1.01-.16-1.74-.47-2.2-.31-.45-.83-.68-1.57-.68-.63,0-1.16.29-1.6.86-.43.57-.65,1.26-.65,2.05v5.22h-1.46v-5.43c0-1.8-.69-2.7-2.08-2.7-.64,0-1.17.27-1.59.81-.42.54-.63,1.24-.63,2.1v5.22h-1.46v-9.15h1.46v1.45h.04c.65-1.11,1.6-1.66,2.84-1.66.63,0,1.17.18,1.63.53.46.35.78.8.96,1.37.68-1.26,1.69-1.89,3.04-1.89,2.01,0,3.02,1.24,3.02,3.72v5.64Z" />
				<path d="m260.43,787.68h-1.46v-11.07c-.11.11-.28.24-.5.39-.21.14-.46.29-.73.43-.27.14-.55.28-.86.4-.3.13-.59.22-.88.29v-1.48c.32-.09.66-.21,1.02-.36.36-.15.72-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.58-.41.8-.61h.55v13.09Z" />
				<path d="m183.86,806.68h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.07.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Zm8-9.32v6.15h1.2v.97h-1.2v2.19h-1.05v-2.19h-4.38v-.92c.41-.46.82-.95,1.23-1.47.42-.52.81-1.05,1.19-1.59.38-.54.73-1.07,1.05-1.6.32-.54.6-1.05.82-1.54h1.14Zm-4.23,6.15h3.18v-4.56c-.32.57-.63,1.07-.92,1.52-.29.45-.57.85-.83,1.22-.26.36-.51.69-.75.99-.24.29-.46.57-.68.84Z" />
				<rect x="194.59" y="797.36" width=".94" height="2.9" />
				<path d="m203.18,803.72c0,.45-.07.87-.22,1.25-.15.38-.35.71-.61.99-.26.28-.57.49-.93.65-.36.15-.75.23-1.17.23-.47,0-.89-.1-1.26-.29-.37-.19-.68-.47-.94-.84-.26-.37-.45-.82-.58-1.34-.13-.53-.2-1.12-.2-1.79,0-.81.09-1.54.27-2.2.18-.66.44-1.23.77-1.7.33-.47.73-.84,1.2-1.09.47-.26.99-.38,1.57-.38.64,0,1.16.09,1.55.27v1.01c-.48-.25-.99-.37-1.52-.37-.42,0-.79.09-1.12.28-.33.19-.62.45-.86.79-.24.34-.42.75-.55,1.23-.13.48-.19,1.02-.19,1.6h.03c.43-.78,1.14-1.16,2.12-1.16.41,0,.77.07,1.1.21.33.14.61.34.84.59.23.25.41.55.54.9s.19.74.19,1.17Zm-1.09.14c0-.32-.04-.62-.12-.88-.08-.26-.2-.48-.36-.66-.15-.18-.34-.32-.57-.42-.23-.1-.48-.15-.77-.15-.26,0-.51.05-.73.15s-.42.24-.58.41c-.16.17-.29.37-.39.6-.09.23-.14.47-.14.72,0,.32.05.62.14.9.09.28.22.52.38.73.16.21.36.37.58.49.23.12.48.18.76.18s.51-.05.73-.15c.22-.1.41-.25.57-.43s.28-.4.36-.65c.09-.26.13-.54.13-.84Z" />
				<path d="m205.73,797.36v2.9h-.94v-2.9h.94Zm2.16,0v2.9h-.94v-2.9h.94Z" />
				<path d="m218.54,800.02l-2.24,3.37,2.2,3.29h-1.24l-1.31-2.16c-.08-.13-.18-.3-.29-.51h-.03s-.12.21-.31.51l-1.33,2.16h-1.23l2.27-3.26-2.17-3.39h1.24l1.29,2.27c.1.17.19.34.28.52h.03l1.66-2.79h1.18Z" />
				<path d="m227.06,806.68h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.07.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Zm7.5-6.87c0-.29-.05-.54-.14-.75-.09-.21-.21-.39-.36-.53-.15-.14-.33-.25-.54-.32-.21-.07-.43-.1-.68-.1-.21,0-.41.03-.61.08-.2.06-.39.13-.58.23-.19.1-.37.22-.55.36-.17.14-.34.29-.49.46v-1.14c.3-.29.63-.51,1-.66.37-.16.83-.23,1.36-.23.38,0,.73.06,1.06.17.32.11.61.27.84.48.24.21.42.47.56.79.14.31.21.67.21,1.07,0,.37-.04.7-.13,1-.08.3-.21.58-.38.84-.17.26-.38.52-.64.76-.26.24-.57.49-.92.74-.44.31-.8.58-1.09.8-.28.22-.51.43-.68.62-.16.19-.28.38-.35.58-.06.19-.1.41-.1.66h4.64v.96h-5.75v-.46c0-.4.04-.75.13-1.05s.23-.59.43-.86c.2-.27.46-.55.78-.82.32-.27.72-.58,1.19-.92.34-.24.62-.47.84-.7.23-.22.41-.44.55-.66.14-.22.24-.44.29-.67.06-.23.09-.47.09-.73Z" />
				<rect x="237.79" y="797.36" width=".94" height="2.9" />
				<path d="m244.45,806.68h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.07.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Zm9.11-4.7c0,.78-.07,1.47-.21,2.07-.14.6-.34,1.11-.61,1.53-.26.41-.59.73-.98.94-.39.21-.83.32-1.32.32-.47,0-.89-.1-1.25-.31-.36-.21-.67-.51-.92-.9-.25-.39-.44-.88-.57-1.45-.13-.58-.19-1.23-.19-1.98,0-.81.07-1.53.2-2.16.14-.62.34-1.15.6-1.57.26-.42.59-.74.98-.96.39-.22.84-.32,1.35-.32,1.95,0,2.93,1.59,2.93,4.78Zm-1.09.1c0-2.65-.63-3.98-1.89-3.98-1.33,0-1.99,1.35-1.99,4.05,0,2.52.65,3.78,1.96,3.78s1.93-1.28,1.93-3.85Z" />
				<path d="m256.12,797.36v2.9h-.94v-2.9h.94Zm2.16,0v2.9h-.94v-2.9h.94Z" />
				<path d="m661.73,355.83v-12.81h3.64c1.11,0,1.99.27,2.63.81.65.54.97,1.25.97,2.12,0,.73-.2,1.36-.59,1.89s-.93.92-1.63,1.14v.04c.86.1,1.55.43,2.07.98.52.55.78,1.26.78,2.14,0,1.1-.39,1.98-1.18,2.66-.79.68-1.78,1.02-2.97,1.02h-3.73Zm1.5-11.45v4.14h1.54c.82,0,1.47-.2,1.94-.59.47-.4.71-.96.71-1.68,0-1.24-.82-1.87-2.46-1.87h-1.72Zm0,5.48v4.61h2.04c.88,0,1.56-.21,2.05-.63.49-.42.73-.99.73-1.71,0-1.51-1.03-2.27-3.09-2.27h-1.72Zm16.12,1.76h-6.46c.02,1.02.3,1.8.82,2.36.52.55,1.24.83,2.16.83,1.03,0,1.98-.34,2.84-1.02v1.38c-.8.58-1.87.88-3.19.88s-2.31-.41-3.05-1.24c-.74-.83-1.11-2-1.11-3.51,0-1.42.4-2.58,1.21-3.47.81-.9,1.81-1.35,3.01-1.35s2.12.39,2.78,1.16c.65.77.98,1.85.98,3.22v.77Zm-1.5-1.24c0-.85-.21-1.5-.62-1.97-.4-.47-.96-.71-1.67-.71s-1.28.25-1.76.74c-.48.49-.78,1.14-.89,1.94h4.94Zm11.51,5.45h-1.46v-1.55h-.04c-.68,1.18-1.73,1.77-3.14,1.77-1.15,0-2.07-.41-2.76-1.22-.68-.82-1.03-1.94-1.03-3.35,0-1.51.38-2.72,1.14-3.64s1.78-1.37,3.05-1.37,2.17.49,2.74,1.48h.04v-5.66h1.46v13.54Zm-1.46-4.14v-1.35c0-.74-.24-1.36-.73-1.88s-1.11-.77-1.86-.77c-.89,0-1.6.33-2.11.98-.51.65-.77,1.56-.77,2.72,0,1.05.24,1.89.73,2.5.49.61,1.16.91,1.98.91s1.48-.29,1.98-.88c.51-.59.77-1.33.77-2.23Zm9.19-3.53c-.26-.2-.63-.29-1.11-.29-.63,0-1.15.29-1.57.88-.42.59-.63,1.39-.63,2.41v4.66h-1.46v-9.15h1.46v1.88h.04c.21-.64.53-1.14.96-1.5.43-.36.91-.54,1.44-.54.38,0,.67.04.88.13v1.52Zm5.41,7.88c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm10.6,8.34c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm19.76,8.13h-1.46v-5.25c0-1.01-.16-1.74-.47-2.2-.31-.45-.83-.68-1.57-.68-.63,0-1.16.29-1.6.86-.43.57-.65,1.26-.65,2.05v5.22h-1.46v-5.43c0-1.8-.69-2.7-2.08-2.7-.64,0-1.17.27-1.59.81-.42.54-.63,1.24-.63,2.1v5.22h-1.46v-9.15h1.46v1.45h.04c.65-1.11,1.6-1.66,2.84-1.66.63,0,1.17.18,1.63.53.46.35.78.8.96,1.37.68-1.26,1.69-1.89,3.04-1.89,2.01,0,3.02,1.24,3.02,3.72v5.64Z" />
				<path d="m746.24,346.38c0-.39-.06-.74-.19-1.03-.12-.29-.29-.53-.5-.72-.21-.2-.46-.34-.74-.44-.29-.1-.6-.14-.93-.14-.29,0-.57.04-.84.12-.27.08-.54.18-.8.32-.26.14-.51.3-.75.49-.24.19-.46.4-.67.63v-1.57c.41-.4.87-.7,1.38-.91.51-.21,1.13-.32,1.87-.32.52,0,1.01.08,1.46.23.45.15.83.37,1.16.66.33.29.58.65.77,1.08.19.43.29.92.29,1.47,0,.51-.06.96-.18,1.38-.11.41-.29.8-.53,1.16-.23.36-.53.71-.88,1.05-.36.33-.78.67-1.26,1.02-.6.43-1.1.79-1.49,1.1-.39.3-.7.59-.93.86-.23.26-.39.53-.48.79-.09.26-.13.57-.13.91h6.38v1.31h-7.9v-.63c0-.55.06-1.03.18-1.45.12-.42.32-.81.59-1.19.27-.38.63-.75,1.07-1.13.45-.38.99-.8,1.63-1.27.46-.33.85-.65,1.16-.96.32-.3.57-.61.76-.91.19-.3.32-.61.4-.92.08-.32.13-.65.13-1Z" />
				<path d="m672.84,374.82h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.06.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Zm7.19,0h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.06.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Z" />
				<rect x="683.57" y="365.5" width=".94" height="2.9" />
				<path d="m692.15,370.12c0,.78-.07,1.47-.21,2.07-.14.6-.34,1.11-.61,1.53-.26.41-.59.73-.98.94-.39.21-.83.32-1.32.32-.47,0-.89-.1-1.25-.31-.36-.21-.67-.51-.92-.9-.25-.39-.44-.88-.57-1.45-.13-.58-.19-1.23-.19-1.98,0-.81.07-1.53.2-2.16.14-.62.34-1.15.6-1.57.26-.42.59-.74.98-.96.39-.22.84-.32,1.35-.32,1.95,0,2.93,1.59,2.93,4.78Zm-1.09.1c0-2.65-.63-3.98-1.89-3.98-1.33,0-1.99,1.35-1.99,4.05,0,2.52.65,3.78,1.96,3.78s1.93-1.28,1.93-3.85Z" />
				<path d="m694.71,365.5v2.9h-.94v-2.9h.94Zm2.16,0v2.9h-.94v-2.9h.94Z" />
				<path d="m707.52,368.17l-2.24,3.37,2.2,3.29h-1.24l-1.31-2.16c-.08-.13-.18-.3-.29-.51h-.03s-.12.21-.31.51l-1.33,2.16h-1.23l2.27-3.26-2.17-3.39h1.24l1.29,2.27c.1.17.19.34.28.52h.03l1.66-2.79h1.18Z" />
				<path d="m716.04,374.82h-1.07v-8.05c-.08.08-.2.18-.36.29-.16.1-.33.21-.53.31-.19.1-.4.2-.62.29-.22.09-.43.16-.64.21v-1.08c.23-.06.48-.15.74-.26.26-.11.52-.24.77-.37.26-.14.5-.28.72-.43.23-.15.42-.3.58-.44h.4v9.53Zm9.11-4.7c0,.78-.07,1.47-.21,2.07-.14.6-.34,1.11-.61,1.53-.26.41-.59.73-.98.94-.39.21-.83.32-1.32.32-.47,0-.89-.1-1.25-.31-.36-.21-.67-.51-.92-.9-.25-.39-.44-.88-.57-1.45-.13-.58-.19-1.23-.19-1.98,0-.81.07-1.53.2-2.16.14-.62.34-1.15.6-1.57.26-.42.59-.74.98-.96.39-.22.84-.32,1.35-.32,1.95,0,2.93,1.59,2.93,4.78Zm-1.09.1c0-2.65-.63-3.98-1.89-3.98-1.33,0-1.99,1.35-1.99,4.05,0,2.52.65,3.78,1.96,3.78s1.93-1.28,1.93-3.85Z" />
				<rect x="726.77" y="365.5" width=".94" height="2.9" />
				<path d="m734.25,365.5v6.15h1.2v.97h-1.2v2.19h-1.05v-2.19h-4.38v-.92c.41-.46.82-.95,1.23-1.47.42-.52.81-1.05,1.19-1.59.38-.54.73-1.07,1.05-1.6.32-.54.6-1.05.82-1.54h1.14Zm-4.23,6.15h3.18v-4.56c-.32.57-.63,1.07-.92,1.52-.29.45-.57.85-.83,1.22-.26.36-.51.69-.75.99-.24.29-.46.57-.68.84Z" />
				<path d="m737.91,365.5v2.9h-.94v-2.9h.94Zm2.16,0v2.9h-.94v-2.9h.94Z" />
				<path d="m612.96,764.89h-2.09l-4.95-5.86c-.18-.22-.3-.37-.34-.45h-.04v6.31h-1.5v-12.81h1.5v6.02h.04c.08-.13.2-.28.34-.44l4.79-5.58h1.87l-5.49,6.15,5.88,6.66Zm2.24-11.47c-.26,0-.49-.09-.67-.27-.18-.18-.28-.4-.28-.68s.09-.5.28-.68c.18-.18.41-.28.67-.28s.49.09.68.28c.19.18.29.41.29.68s-.1.49-.29.67c-.18.18-.41.28-.68.28Zm.71,11.47h-1.46v-9.15h1.46v9.15Zm7.19-.09c-.35.19-.8.29-1.37.29-1.6,0-2.4-.89-2.4-2.68v-5.41h-1.57v-1.25h1.57v-2.23l1.46-.47v2.71h2.3v1.25h-2.3v5.15c0,.61.1,1.05.31,1.31.21.26.55.39,1.04.39.37,0,.69-.1.96-.3v1.25Zm8.18-.33c-.7.42-1.54.63-2.5.63-1.3,0-2.36-.42-3.16-1.27-.8-.85-1.2-1.95-1.2-3.3,0-1.51.43-2.72,1.3-3.63.86-.92,2.02-1.38,3.46-1.38.8,0,1.51.15,2.13.45v1.5c-.68-.48-1.41-.71-2.18-.71-.93,0-1.7.34-2.3,1.01-.6.67-.89,1.55-.89,2.63s.28,1.92.84,2.54c.57.62,1.32.93,2.27.93.8,0,1.55-.26,2.25-.79v1.39Zm9.8.42h-1.46v-5.27c0-1.91-.71-2.86-2.13-2.86-.71,0-1.32.28-1.8.83-.49.55-.73,1.25-.73,2.12v5.18h-1.46v-13.54h1.46v5.91h.04c.7-1.16,1.7-1.73,3-1.73,2.06,0,3.09,1.24,3.09,3.72v5.64Zm10.1-4.21h-6.46c.02,1.02.3,1.8.82,2.36s1.24.83,2.16.83c1.03,0,1.98-.34,2.84-1.02v1.38c-.8.58-1.87.88-3.19.88s-2.31-.41-3.05-1.24c-.74-.83-1.11-2-1.11-3.51,0-1.42.4-2.58,1.21-3.47.81-.9,1.81-1.35,3.01-1.35s2.12.39,2.78,1.16c.65.77.98,1.85.98,3.22v.77Zm-1.5-1.24c0-.85-.21-1.5-.62-1.97-.4-.47-.96-.71-1.67-.71s-1.28.25-1.76.74-.78,1.14-.89,1.94h4.94Zm11.3,5.45h-1.46v-5.22c0-1.94-.71-2.91-2.13-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.22h-1.46v-9.15h1.46v1.52h.04c.69-1.16,1.69-1.73,3-1.73,1,0,1.77.32,2.3.97.53.64.79,1.57.79,2.8v5.59Z" />
				<path d="m751.65,630.64h-6.79v-12.81h6.5v1.36h-5v4.26h4.63v1.35h-4.63v4.48h5.29v1.36Zm9.88,0h-1.46v-5.22c0-1.94-.71-2.91-2.13-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.22h-1.46v-9.15h1.46v1.52h.04c.69-1.16,1.69-1.73,3-1.73,1,0,1.77.32,2.3.97.53.64.8,1.58.8,2.8v5.59Zm7.02-.09c-.35.19-.8.29-1.37.29-1.6,0-2.4-.89-2.4-2.68v-5.41h-1.57v-1.25h1.57v-2.23l1.46-.47v2.71h2.3v1.25h-2.3v5.15c0,.61.1,1.05.31,1.31.21.26.55.39,1.04.39.37,0,.69-.1.96-.3v1.25Zm6.74-7.57c-.26-.2-.63-.29-1.11-.29-.63,0-1.15.29-1.57.88-.42.59-.63,1.39-.63,2.41v4.66h-1.46v-9.15h1.46v1.88h.04c.21-.64.53-1.14.96-1.5.43-.36.91-.54,1.44-.54.38,0,.67.04.88.13v1.52Zm8.89-1.48l-4.21,10.61c-.75,1.89-1.8,2.84-3.16,2.84-.38,0-.7-.04-.96-.12v-1.31c.32.11.6.16.87.16.74,0,1.29-.44,1.66-1.32l.73-1.73-3.57-9.13h1.63l2.47,7.04c.03.09.09.32.19.7h.05c.03-.14.09-.37.18-.68l2.6-7.06h1.52Z" />
				<path d="m842.71,625.92v-12.81h3.64c1.11,0,1.99.27,2.63.81s.97,1.25.97,2.12c0,.73-.2,1.36-.59,1.89-.39.54-.93.92-1.63,1.14v.04c.86.1,1.55.43,2.07.98.52.55.78,1.26.78,2.14,0,1.1-.39,1.98-1.18,2.66-.79.68-1.78,1.02-2.97,1.02h-3.73Zm1.5-11.45v4.14h1.54c.82,0,1.47-.2,1.94-.59.47-.4.71-.96.71-1.68,0-1.24-.82-1.87-2.46-1.87h-1.72Zm0,5.48v4.61h2.04c.88,0,1.56-.21,2.05-.63.49-.42.73-.99.73-1.71,0-1.51-1.03-2.27-3.09-2.27h-1.72Zm15.33,5.97h-1.46v-1.43h-.04c-.64,1.1-1.57,1.64-2.81,1.64-.91,0-1.63-.24-2.14-.72-.51-.48-.77-1.12-.77-1.92,0-1.71,1.01-2.7,3.02-2.98l2.74-.38c0-1.55-.63-2.33-1.88-2.33-1.1,0-2.1.38-2.98,1.13v-1.5c.9-.57,1.94-.86,3.11-.86,2.15,0,3.22,1.14,3.22,3.41v5.95Zm-1.46-4.63l-2.21.3c-.68.1-1.19.26-1.54.51-.35.24-.52.66-.52,1.28,0,.45.16.81.47,1.1.32.28.75.42,1.28.42.73,0,1.32-.25,1.8-.76.48-.51.71-1.16.71-1.94v-.91Zm8.47,4.54c-.35.19-.8.29-1.37.29-1.6,0-2.4-.89-2.4-2.68v-5.41h-1.57v-1.25h1.57v-2.23l1.46-.47v2.71h2.3v1.25h-2.3v5.15c0,.61.1,1.05.31,1.31.21.26.55.39,1.04.39.37,0,.69-.1.96-.3v1.25Zm9.55.09h-1.46v-5.27c0-1.91-.71-2.86-2.13-2.86-.71,0-1.32.28-1.8.83-.49.55-.73,1.25-.73,2.12v5.18h-1.46v-13.54h1.46v5.91h.04c.7-1.16,1.7-1.73,3-1.73,2.06,0,3.09,1.24,3.09,3.72v5.64Z" />
				<path d="m408.47,843.18v-12.81h3.64c1.11,0,1.99.27,2.63.81.65.54.97,1.25.97,2.12,0,.73-.2,1.36-.59,1.89-.39.54-.93.92-1.63,1.14v.04c.86.1,1.55.43,2.07.98.52.55.78,1.26.78,2.14,0,1.1-.39,1.98-1.18,2.66-.79.68-1.78,1.02-2.97,1.02h-3.73Zm1.5-11.45v4.14h1.54c.82,0,1.47-.2,1.94-.59.47-.4.71-.96.71-1.68,0-1.24-.82-1.87-2.46-1.87h-1.72Zm0,5.48v4.61h2.04c.88,0,1.56-.21,2.05-.63.49-.42.73-.99.73-1.71,0-1.51-1.03-2.27-3.09-2.27h-1.72Zm15.33,5.97h-1.46v-1.43h-.04c-.64,1.1-1.57,1.64-2.81,1.64-.91,0-1.63-.24-2.14-.72-.51-.48-.77-1.12-.77-1.92,0-1.71,1.01-2.7,3.02-2.98l2.74-.38c0-1.55-.63-2.33-1.88-2.33-1.1,0-2.1.38-2.98,1.13v-1.5c.9-.57,1.94-.86,3.11-.86,2.15,0,3.22,1.14,3.22,3.41v5.95Zm-1.46-4.63l-2.21.3c-.68.1-1.19.26-1.54.51-.35.24-.52.66-.52,1.28,0,.45.16.81.47,1.1.32.28.75.42,1.28.42.73,0,1.32-.25,1.8-.76.48-.51.71-1.16.71-1.94v-.91Zm8.47,4.54c-.35.19-.8.29-1.37.29-1.6,0-2.4-.89-2.4-2.68v-5.41h-1.57v-1.25h1.57v-2.23l1.46-.47v2.71h2.3v1.25h-2.3v5.15c0,.61.1,1.05.31,1.31.21.26.55.39,1.04.39.37,0,.69-.1.96-.3v1.25Zm9.55.09h-1.46v-5.27c0-1.91-.71-2.86-2.13-2.86-.71,0-1.32.28-1.8.83-.49.55-.73,1.25-.73,2.12v5.18h-1.46v-13.54h1.46v5.91h.04c.7-1.16,1.7-1.73,3-1.73,2.06,0,3.09,1.24,3.09,3.72v5.64Z" />
				<path d="m464.67,151.62v4.84h-1.5v-12.81h3.52c1.37,0,2.43.33,3.18,1,.76.67,1.13,1.61,1.13,2.82s-.42,2.21-1.26,2.98c-.83.77-1.96,1.16-3.39,1.16h-1.69Zm0-6.61v5.25h1.57c1.04,0,1.83-.24,2.37-.71.55-.48.82-1.15.82-2.01,0-1.69-1-2.54-3-2.54h-1.76Zm14.96,11.45h-1.46v-1.43h-.04c-.64,1.1-1.57,1.64-2.81,1.64-.91,0-1.63-.24-2.14-.72-.51-.48-.77-1.12-.77-1.92,0-1.71,1.01-2.7,3.02-2.98l2.74-.38c0-1.55-.63-2.33-1.88-2.33-1.1,0-2.1.38-2.98,1.13v-1.5c.9-.57,1.94-.86,3.11-.86,2.15,0,3.22,1.14,3.22,3.41v5.95Zm-1.46-4.63l-2.21.3c-.68.1-1.19.26-1.54.51-.35.24-.52.66-.52,1.28,0,.45.16.81.47,1.1.32.28.75.42,1.28.42.73,0,1.32-.25,1.8-.76.48-.51.71-1.16.71-1.94v-.91Zm8.34,4.54c-.35.19-.8.29-1.37.29-1.6,0-2.4-.89-2.4-2.68v-5.41h-1.57v-1.25h1.57v-2.23l1.46-.47v2.71h2.3v1.25h-2.3v5.15c0,.61.1,1.05.31,1.31.21.26.55.39,1.04.39.37,0,.69-.1.96-.3v1.25Zm2.58-11.38c-.26,0-.49-.09-.67-.27s-.28-.4-.28-.68.09-.5.28-.68c.18-.18.41-.28.67-.28s.49.09.68.28c.19.18.29.4.29.68s-.1.49-.29.67c-.18.18-.41.28-.68.28Zm.71,11.47h-1.46v-9.15h1.46v9.15Zm6.65.21c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56c.55.63,1.3.94,2.22.94s1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Z" />
				<polygon points="509.01 143.65 502.87 158.58 501.5 158.58 507.63 143.65 509.01 143.65" />
				<path d="m510.51,156.46v-12.81h3.64c1.11,0,1.99.27,2.63.81.65.54.97,1.25.97,2.12,0,.73-.2,1.36-.59,1.89-.39.54-.93.92-1.63,1.14v.04c.86.1,1.55.43,2.07.98.52.55.78,1.26.78,2.14,0,1.1-.39,1.98-1.18,2.66-.79.68-1.78,1.02-2.97,1.02h-3.73Zm1.5-11.45v4.14h1.54c.82,0,1.47-.2,1.94-.59.47-.4.71-.96.71-1.68,0-1.24-.82-1.87-2.46-1.87h-1.72Zm0,5.48v4.61h2.04c.88,0,1.56-.21,2.05-.63.49-.42.73-.99.73-1.71,0-1.51-1.03-2.27-3.09-2.27h-1.72Zm15.33,5.97h-1.46v-1.43h-.04c-.64,1.1-1.58,1.64-2.81,1.64-.91,0-1.63-.24-2.14-.72-.51-.48-.77-1.12-.77-1.92,0-1.71,1.01-2.7,3.02-2.98l2.74-.38c0-1.55-.63-2.33-1.88-2.33-1.1,0-2.1.38-2.98,1.13v-1.5c.9-.57,1.94-.86,3.11-.86,2.15,0,3.22,1.14,3.22,3.41v5.95Zm-1.46-4.63l-2.21.3c-.68.1-1.19.27-1.54.51-.35.24-.52.66-.52,1.28,0,.45.16.81.47,1.1.32.28.75.42,1.28.42.73,0,1.32-.25,1.8-.76.48-.51.71-1.16.71-1.94v-.91Zm5.69,4.63h-1.46v-13.54h1.46v13.54Zm9.19-.42c-.7.42-1.54.63-2.5.63-1.3,0-2.36-.42-3.16-1.27-.8-.85-1.2-1.95-1.2-3.3,0-1.51.43-2.72,1.3-3.63.86-.92,2.02-1.38,3.46-1.38.8,0,1.51.15,2.13.45v1.5c-.68-.48-1.41-.71-2.18-.71-.93,0-1.7.34-2.3,1.01-.6.67-.89,1.55-.89,2.63s.28,1.92.84,2.54c.57.62,1.32.93,2.27.93.8,0,1.55-.26,2.25-.79v1.39Zm6.04.63c-1.35,0-2.43-.43-3.24-1.28-.8-.86-1.21-1.99-1.21-3.4,0-1.54.42-2.74,1.26-3.6.84-.86,1.97-1.3,3.4-1.3s2.43.42,3.19,1.26c.77.84,1.15,2,1.15,3.49s-.41,2.63-1.24,3.51c-.82.88-1.93,1.31-3.31,1.31Zm.11-8.34c-.94,0-1.69.32-2.23.96-.55.64-.82,1.52-.82,2.64s.28,1.94.83,2.56,1.3.94,2.22.94,1.67-.31,2.18-.92c.51-.61.77-1.49.77-2.62s-.26-2.02-.77-2.64c-.51-.62-1.23-.93-2.18-.93Zm14.38,8.13h-1.46v-5.22c0-1.94-.71-2.91-2.13-2.91-.73,0-1.34.28-1.82.83-.48.55-.71,1.24-.71,2.08v5.22h-1.46v-9.15h1.46v1.52h.04c.69-1.16,1.69-1.73,3-1.73,1,0,1.77.32,2.3.97.53.64.79,1.57.79,2.8v5.59Zm10.04-9.15l-4.21,10.61c-.75,1.89-1.8,2.84-3.16,2.84-.38,0-.7-.04-.96-.12v-1.31c.32.11.6.16.87.16.74,0,1.29-.44,1.66-1.32l.73-1.73-3.57-9.13h1.63l2.47,7.04c.03.09.09.32.19.7h.05c.03-.14.09-.37.18-.68l2.6-7.06h1.52Z" />
				<path d="m465.42,729.04l-2.3,8.15h-1.12l-1.68-5.96c-.07-.25-.12-.53-.13-.83h-.02c-.02.28-.07.55-.15.82l-1.69,5.97h-1.11l-2.39-8.15h1.05l1.73,6.25c.07.26.12.53.14.82h.03c.02-.2.08-.47.18-.82l1.8-6.25h.92l1.73,6.3c.06.22.11.47.14.76h.02c.02-.2.07-.46.15-.78l1.67-6.27h1.03Z" />
				<polygon points="470.18 729.04 466.27 738.54 465.4 738.54 469.3 729.04 470.18 729.04" />
				<path d="m471.13,737.19v-8.15h2.25c2.87,0,4.31,1.32,4.31,3.97,0,1.26-.4,2.27-1.2,3.03-.8.76-1.86,1.14-3.2,1.14h-2.16Zm.95-7.29v6.42h1.22c1.07,0,1.9-.29,2.49-.86.59-.57.89-1.38.89-2.43,0-2.09-1.11-3.13-3.33-3.13h-1.27Z" />
			</g>
		</g>
	)
}

export default PlanJJ
